/* ============================================
   LIMPIACLEAN B2B - Shopify Theme JavaScript
   Cart API, Pricing Engine, Animations, Product
   ============================================ */

/* --- PRICING ENGINE --- */
// BY-AMOUNT ONLY — alineado con Shopify automatic discounts ($1.5K/$5K/$20K/$80K).
// Si Shopify cambia thresholds, actualizar aqui Y en netlify/functions/lib/shopify-catalog.js
// Y en data/pricing-tiers.json Y en shopify-theme/config/settings_data.json.
const LimpiaCleanPricing = (function() {
  let tiers = [];

  function init() {
    var defaultTiers = [
      { key: 'retail',   label: 'Retail',   icon: '🏷️', minQty: 1,     maxQty: 99,    minAmt: 0,      maxAmt: 4999,   multiplier: 1.00, discountPercent: 0 },
      { key: 'mayoreo',  label: 'Mayoreo',  icon: '📦', minQty: 100,   maxQty: 999,   minAmt: 5000,   maxAmt: 19999,  multiplier: 0.90, discountPercent: 10 },
      { key: 'silver',   label: 'Plata',    icon: '🥈', minQty: 1000,  maxQty: 4999,  minAmt: 20000,  maxAmt: 39999,  multiplier: 0.80, discountPercent: 20 },
      { key: 'gold',     label: 'Oro',      icon: '🥇', minQty: 5000,  maxQty: 19999, minAmt: 40000,  maxAmt: 149999, multiplier: 0.70, discountPercent: 30 },
      { key: 'platinum', label: 'Platino',  icon: '💎', minQty: 20000, maxQty: null,  minAmt: 150000, maxAmt: null,   multiplier: 0.60, discountPercent: 40 }
    ];
    try {
      var configTiers = window.LimpiaClean && window.LimpiaClean.tiers;
      tiers = (Array.isArray(configTiers) && configTiers.length > 0) ? configTiers : defaultTiers;
    } catch(e) {
      tiers = defaultTiers;
    }
  }

  function getTiers() { return tiers; }

  // Fuente de verdad: tier por monto $ retail (replica Shopify automatic discounts)
  function getTierForAmount(amount) {
    for (var i = tiers.length - 1; i >= 0; i--) {
      var t = tiers[i];
      if (typeof t.minAmt === 'number') {
        if (amount >= t.minAmt) return t;
      } else if (amount >= t.minQty) {
        return t;
      }
    }
    return tiers[0];
  }

  // LEGACY: prefiere getTierForAmount(). Mantengo por compat con call-sites
  // que aun no tienen monto. Si se pasa amount, delega a getTierForAmount.
  function getTierForQty(qty, amount) {
    if (typeof amount === 'number' && isFinite(amount)) return getTierForAmount(amount);
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].minQty) return tiers[i];
    }
    return tiers[0];
  }

  function getNextTier(currentTierKey) {
    const idx = tiers.findIndex(t => t.key === currentTierKey);
    if (idx < tiers.length - 1) return tiers[idx + 1];
    return null;
  }

  function getFullPriceBreakdown(basePrice, qty) {
    const retailTotal = basePrice * qty;
    const tier = getTierForAmount(retailTotal);
    const unitPrice = basePrice * tier.multiplier;
    const total = unitPrice * qty;
    const savings = retailTotal - total;
    const nextTier = getNextTier(tier.key);
    let nextTierMsg = null;
    if (nextTier) {
      var hasAmt = typeof nextTier.minAmt === 'number';
      var amtNeeded = hasAmt ? Math.max(0, nextTier.minAmt - retailTotal) : 0;
      var needed = hasAmt
        ? (basePrice > 0 ? Math.ceil(amtNeeded / basePrice) : 0)
        : Math.max(0, nextTier.minQty - qty);
      nextTierMsg = {
        needed: needed,
        amtNeeded: amtNeeded,
        tierLabel: nextTier.label,
        tierIcon: nextTier.icon,
        unitPrice: basePrice * nextTier.multiplier
      };
    }
    return { tier, unitPrice, total, retailTotal, savings, savingsPercent: tier.discountPercent, nextTier: nextTierMsg };
  }

  function formatMXN(amount) {
    var n = (typeof amount === 'number' && isFinite(amount)) ? amount : 0;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return { init, getTiers, getTierForQty, getTierForAmount, getNextTier, getFullPriceBreakdown, formatMXN };
})();
LimpiaCleanPricing.init();


/* --- CART (Shopify Cart API) --- */
const LimpiaCleanCart = (function() {
  function toggle() {
    // Close mobile nav if open
    var mobileNav = document.getElementById('mobile-nav');
    if (mobileNav && mobileNav.classList.contains('open')) {
      LimpiaCleanApp.toggleMobileNav();
    }
    var sidebar = document.getElementById('cart-sidebar');
    var overlay = document.getElementById('cart-overlay');
    if (sidebar) sidebar.classList.toggle('open');
    if (overlay) overlay.classList.toggle('active');
    document.body.classList.toggle('cart-open', sidebar && sidebar.classList.contains('open'));
    // Fetch fresh cart data when opening
    if (sidebar && sidebar.classList.contains('open')) {
      refreshUI();
    }
  }

  function open() {
    // Close mobile nav if open
    var mobileNav = document.getElementById('mobile-nav');
    if (mobileNav && mobileNav.classList.contains('open')) {
      LimpiaCleanApp.toggleMobileNav();
    }
    var sidebar = document.getElementById('cart-sidebar');
    var overlay = document.getElementById('cart-overlay');
    if (sidebar) sidebar.classList.add('open');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('cart-open');
  }

  function close() {
    var sidebar = document.getElementById('cart-sidebar');
    var overlay = document.getElementById('cart-overlay');
    if (sidebar) sidebar.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    document.body.classList.remove('cart-open');
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function addItem(variantId, quantity) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!res.ok) throw new Error('Error al agregar');
      const data = await res.json();
      await refreshUI();
      open();
      LimpiaCleanApp.showToast('Producto agregado al carrito', 'success');
      return data;
    } catch(e) {
      LimpiaCleanApp.showToast('Error al agregar al carrito', 'error');
      return null;
    }
  }

  async function updateLine(line, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!res.ok) throw new Error('Error al actualizar');
      var cart = await res.json();

      // Update sidebar
      updateCount(cart.item_count);
      updateSidebar(cart);

      // If on the /cart page, update the cart page DOM too
      if (window.location.pathname === '/cart') {
        updateCartPage(cart);
      }

      if (quantity === 0) {
        LimpiaCleanApp.showToast('Producto eliminado', 'info');
      }
    } catch(e) {
      LimpiaCleanApp.showToast('Error al actualizar carrito', 'error');
    }
  }

  function updateCartPage(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    // Pre-calculate tier summary for per-item suggestions
    var summary = cartTierSummary(cart);
    var currentTier = summary.tier;
    var nextTierInfo = summary.nextTier;
    var nextTierObj = nextTierInfo ? LimpiaCleanPricing.getNextTier(currentTier.key) : null;

    // Update each cart item on the page
    var cartItems = document.querySelectorAll('#cart-form .cart-page-item-wrapper, #cart-form .cart-item');
    var cartItemsContainer = cartItems.length > 0 ? cartItems[0].parentNode : null;

    if (cartItemsContainer) {
      var html = '';
      cart.items.forEach(function(item, index) {
        var line = index + 1;
        var imgUrl = item.image || '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var breakdown = itemBreakdown(item);
        var suggestion = nextTierObj ? itemTierSuggestion(item, summary, currentTier, nextTierObj) : '';
        html +=
          '<div class="cart-page-item-wrapper" data-variant-id="' + item.variant_id + '" data-handle="' + (item.handle || '') + '" data-line="' + line + '">' +
          '<div class="cart-item" style="display: flex; gap: var(--space-5); padding: var(--space-5); background: var(--neutral-0); border-radius: var(--radius-lg); border: 1px solid var(--neutral-200);">' +
          '<a href="' + item.url + '" style="flex-shrink: 0;">' +
          (imgUrl ? '<img src="' + imgUrl + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="120" height="120" style="border-radius: var(--radius-md);" loading="lazy">' : '') +
          '</a>' +
          '<div style="flex: 1; min-width: 0;">' +
          '<a href="' + item.url + '" style="font-weight: var(--font-bold); color: var(--neutral-800); text-decoration: none;">' + item.product_title + '</a>' +
          (variantTitle ? '<p style="font-size: var(--text-sm); color: var(--neutral-500);">' + variantTitle + '</p>' : '') +
          '<p style="font-size: var(--text-sm); color: var(--neutral-400);">' + (item.product_type || '') + '</p>' +
          (breakdown ? '<p class="cart-item-breakdown" style="font-size:var(--text-xs);color:var(--primary-600);font-weight:var(--font-semibold);margin-top:var(--space-1);">📦 ' + breakdown + '</p>' : '') +
          '<div style="display: flex; align-items: center; gap: var(--space-4); margin-top: var(--space-3);">' +
          '<div class="qty-group" style="transform: scale(0.85); transform-origin: left center;">' +
          '<button type="button" class="qty-btn" onclick="LimpiaCleanCart.updateLine(' + line + ', ' + Math.max(0, item.quantity - 1) + ')">−</button>' +
          '<input type="number" name="updates[]" class="qty-input" value="' + item.quantity + '" min="0" data-line="' + line + '" onchange="LimpiaCleanCart.updateLine(' + line + ', parseInt(this.value))">' +
          '<button type="button" class="qty-btn" onclick="LimpiaCleanCart.updateLine(' + line + ', ' + (item.quantity + 1) + ')">+</button>' +
          '</div>' +
          '<span style="font-weight: var(--font-extrabold); font-size: var(--text-lg); color: var(--primary-600);">' + formatShopifyMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '</div>' +
          '<button type="button" class="cart-item-remove" onclick="LimpiaCleanCart.updateLine(' + line + ', 0)" aria-label="Eliminar" style="position: static; align-self: flex-start;">&times;</button>' +
          '</div>' +
          suggestion +
          '</div>';
      });
      cartItemsContainer.innerHTML = html;

      // Async: populate alternative color/size suggestions on cart page
      populateAlternativeSuggestions();
    }

    // Update summary with discount breakdown + free shipping
    updateCartPageSummary(cart);

    // Update tier summary on cart page
    var tierContainer = document.getElementById('cart-page-tier-summary');
    if (tierContainer) {
      tierContainer.innerHTML = buildTierSummaryHTML(summary);
    }
  }

  // Update the cart page summary with proper discount breakdown
  function updateCartPageSummary(cart) {
    var summaryBox = document.getElementById('cart-page-summary');
    if (!summaryBox) return;

    var originalTotal = cart.original_total_price || cart.total_price;
    var shopifyDiscount = cart.total_discount || 0;
    var discountApps = cart.cart_level_discount_applications || [];
    var hasDiscount = shopifyDiscount > 0 && discountApps.length > 0;

    var html = '<h3 style="margin-bottom: var(--space-5);">Resumen del pedido</h3>';

    // Subtotal (before discounts)
    html += '<div class="cart-line"><span>Subtotal:</span><span id="cart-page-subtotal">' + formatShopifyMoney(originalTotal) + '</span></div>';

    // Discount lines
    if (hasDiscount) {
      discountApps.forEach(function(d) {
        html += '<div class="cart-line" style="margin-top: var(--space-2); color: var(--success);">' +
          '<span style="display: flex; align-items: center; gap: var(--space-1);">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>' +
          d.title + ':</span>' +
          '<span>-' + formatShopifyMoney(d.total_allocated_amount) + '</span></div>';
      });
    }

    // Shipping
    html += '<div class="cart-line" style="margin-top: var(--space-2);"><span>Envio:</span>' +
      '<span style="color: var(--neutral-500); font-size: var(--text-sm);">Calculado al pagar</span></div>';

    // Total
    html += '<div class="cart-line total"><span>Total:</span><span id="cart-page-total">' + formatShopifyMoney(cart.total_price) + '</span></div>';

    // Savings badge
    if (hasDiscount) {
      html += '<div style="margin-top: var(--space-2); padding: var(--space-2) var(--space-3); background: var(--success-light); border-radius: var(--radius-md); font-size: var(--text-xs); color: var(--success); text-align: center; font-weight: var(--font-semibold);">Ahorro total: ' + formatShopifyMoney(shopifyDiscount) + '</div>';
    }

    // Buttons
    html += '<button type="submit" name="checkout" class="btn btn-primary btn-block btn-lg" style="margin-top: var(--space-4); margin-bottom: var(--space-3);">Proceder al Pago</button>';
    html += '<a href="/collections" class="btn btn-outline btn-block">Seguir comprando</a>';

    // Free shipping message — lee desde settings de Shopify
    var FREE_SHIPPING_CENTS = (window.LimpiaClean && window.LimpiaClean.freeShippingThreshold) || 500000;
    if (cart.total_price < FREE_SHIPPING_CENTS) {
      var remaining = formatShopifyMoney(FREE_SHIPPING_CENTS - cart.total_price);
      html += '<div style="margin-top: var(--space-4); padding: var(--space-3); background: var(--info-light); border-radius: var(--radius-md); font-size: var(--text-xs); color: var(--info);">' +
        '\uD83D\uDE9A Agrega ' + remaining + ' mas para envio gratis en CDMX.</div>';
    } else {
      html += '<div style="margin-top: var(--space-4); padding: var(--space-3); background: var(--success-light); border-radius: var(--radius-md); font-size: var(--text-xs); color: var(--success);">' +
        '\u2705 Envio gratis en CDMX.</div>';
    }

    summaryBox.innerHTML = html;
  }

  async function refreshUI() {
    const cart = await fetchCart();
    updateCount(cart.item_count);
    updateSidebar(cart);
    // If on /cart page, update tier summary + per-item suggestions
    if (window.location.pathname === '/cart') {
      updateCartPageItemSuggestions(cart);
    }
    return cart;
  }

  // Populate per-item tier suggestions on the /cart page (initial load + after refreshUI)
  function updateCartPageItemSuggestions(cart) {
    if (!cart || cart.item_count === 0) return;

    var summary = cartTierSummary(cart);
    var currentTier = summary.tier;
    var nextTierInfo = summary.nextTier;
    var nextTierObj = nextTierInfo ? LimpiaCleanPricing.getNextTier(currentTier.key) : null;

    // Update tier summary container
    var tierContainer = document.getElementById('cart-page-tier-summary');
    if (tierContainer) {
      tierContainer.innerHTML = buildTierSummaryHTML(summary);
    }

    // Update order summary with proper discount breakdown
    updateCartPageSummary(cart);

    // Populate per-item suggestion placeholders
    var suggestionDivs = document.querySelectorAll('.cart-page-item-suggestion');
    suggestionDivs.forEach(function(div) {
      var variantId = parseInt(div.getAttribute('data-variant-id'));
      var handle = div.getAttribute('data-handle') || '';

      // Find the matching cart item
      var matchingItem = null;
      cart.items.forEach(function(item) {
        if (item.variant_id === variantId) matchingItem = item;
      });

      if (!matchingItem) {
        div.innerHTML = '';
        return;
      }

      // Make sure the item has handle for alt suggestions
      if (!matchingItem.handle && handle) matchingItem.handle = handle;

      var suggestion = nextTierObj ? itemTierSuggestion(matchingItem, summary, currentTier, nextTierObj) : '';
      div.innerHTML = suggestion;
    });

    // Async: populate alternative color/size suggestions
    populateAlternativeSuggestions();
  }

  function updateCount(count) {
    var countEls = document.querySelectorAll('#cart-count, .cart-count');
    countEls.forEach(function(el) {
      el.textContent = count;
      el.classList.remove('bounce');
      void el.offsetWidth;
      if (count > 0) el.classList.add('bounce');
    });
  }

  function sidebarImgUrl(url) {
    if (!url) return '';
    return url.replace(/(\.\w+)(\?.*)?$/, '_100x100$1$2');
  }

  // Detect pieces per unit from product title (e.g. "50 Pack" → 50)
  var CAJA_PACKS = 6; // default packs per caja (fallback)
  var GUANTES_PACK_SIZE = 12; // pares per pack for guantes

  function detectPPU(title) {
    if (!title) return 1;
    var m = title.toLowerCase().match(/(\d+)\s*pack/);
    var n = m ? parseInt(m[1], 10) : 1;
    return (n > 0 && isFinite(n)) ? n : 1;
  }

  // Enhanced: detect total pieces per cart unit considering variant (caja/pack/individual)
  function detectItemPieces(item) {
    var vtitle = (item.variant_title || '').toLowerCase();
    var ptitle = (item.product_title || '').toLowerCase();
    var ppu = detectPPU(ptitle); // pieces from product title (e.g. "50 Pack" → 50)
    var isCaja = vtitle.indexOf('caja') >= 0;

    // 1. Caja variant: "Caja con 6 Packs (300 piezas)" or "Caja con 10 Paquetes (100 piezas)"
    if (isCaja) {
      // Try explicit total piece count first
      var cajaPzMatch = vtitle.match(/(\d+)\s*pieza/);
      var cajaPacksMatch = vtitle.match(/(\d+)\s*(?:pack|paquete)/i);
      if (cajaPzMatch) {
        var cp = cajaPacksMatch ? parseInt(cajaPacksMatch[1]) : (ppu > 1 ? Math.round(parseInt(cajaPzMatch[1]) / ppu) : 1);
        return { pieces: parseInt(cajaPzMatch[1]), isCaja: true, ppu: ppu, cajaPacks: cp };
      }
      // Caja with packs but no explicit piece count: "Caja con 10 Packs" × ppu
      if (cajaPacksMatch && ppu > 1) {
        var cp = parseInt(cajaPacksMatch[1]);
        return { pieces: cp * ppu, isCaja: true, ppu: ppu, cajaPacks: cp };
      }
      // Caja with direct pz/par count: "CAJA CON 40 PZS"
      var directPz = vtitle.match(/(?:con|de)\s*(\d+)\s*(?:pz|par|unid)/i);
      if (directPz) {
        return { pieces: parseInt(directPz[1]), isCaja: true, ppu: ppu, cajaPacks: 1 };
      }
    }

    // 2. Pack/Paquete variant: "Paquete con 10 piezas"
    if (vtitle.indexOf('pack') >= 0 || vtitle.indexOf('paquete') >= 0) {
      var packPzMatch = vtitle.match(/(\d+)\s*(?:pieza|pz)/i);
      if (packPzMatch) {
        return { pieces: parseInt(packPzMatch[1]), isCaja: false, ppu: ppu, cajaPacks: CAJA_PACKS };
      }
    }

    // 3. Explicit piece count in variant title (non-caja, non-pack): e.g. "10 piezas"
    var pzMatch = vtitle.match(/(\d+)\s*pieza/);
    if (pzMatch) {
      return { pieces: parseInt(pzMatch[1]), isCaja: false, ppu: ppu, cajaPacks: CAJA_PACKS };
    }

    // 4. Fallback: product title PPU only
    return { pieces: ppu, isCaja: false, ppu: ppu, cajaPacks: CAJA_PACKS };
  }

  // Detect if cart item is guantes (sold in pares)
  function detectGuantes(item) {
    if (!item) return false;
    var title = (item.product_title || '').toLowerCase();
    var type = (item.product_type || '').toLowerCase();
    return type.indexOf('guante') >= 0 || title.indexOf('guante') >= 0;
  }

  // Build breakdown text for a cart item
  function itemBreakdown(item) {
    var info = detectItemPieces(item);
    var totalPcs = item.quantity * info.pieces;

    if (info.isCaja) {
      // Caja variant: qty = cajas
      var totalPacks = item.quantity * info.cajaPacks;
      var parts = [item.quantity + (item.quantity === 1 ? ' caja' : ' cajas')];
      if (info.cajaPacks > 1) parts.push(totalPacks + ' packs');
      parts.push(totalPcs.toLocaleString() + ' pzs');
      return parts.join(' = ');

    } else if (info.ppu > 1) {
      // Pack product (e.g. 50 Pack Microfibra) — qty = packs
      var numCajas = Math.floor(item.quantity / info.cajaPacks);
      var remainPacks = item.quantity % info.cajaPacks;
      var parts = [];
      if (numCajas > 0 && remainPacks === 0) {
        parts.push(numCajas + (numCajas === 1 ? ' caja' : ' cajas'));
      } else if (numCajas > 0) {
        parts.push(numCajas + (numCajas === 1 ? ' caja' : ' cajas') + ' + ' + remainPacks + (remainPacks === 1 ? ' pack' : ' packs'));
      } else {
        parts.push(item.quantity + (item.quantity === 1 ? ' pack' : ' packs'));
      }
      parts.push(totalPcs.toLocaleString() + ' pzs');
      return parts.join(' = ');

    } else if (detectGuantes(item)) {
      // Guantes: qty = pares, 12 pares/pack, 6 packs/caja = 72 pares/caja
      var qty = item.quantity;
      var paresPerCaja = GUANTES_PACK_SIZE * CAJA_PACKS; // 72
      var numCajas = Math.floor(qty / paresPerCaja);
      var remainAfterCajas = qty % paresPerCaja;
      var numPacks = Math.floor(remainAfterCajas / GUANTES_PACK_SIZE);
      var remainPares = remainAfterCajas % GUANTES_PACK_SIZE;
      var parts = [];
      if (numCajas > 0) parts.push(numCajas + (numCajas === 1 ? ' caja' : ' cajas'));
      if (numPacks > 0) parts.push(numPacks + (numPacks === 1 ? ' pack' : ' packs'));
      if (remainPares > 0) parts.push(remainPares + (remainPares === 1 ? ' par' : ' pares'));
      if (parts.length === 0) return '';
      return qty + ' pares = ' + parts.join(' + ');
    }

    return '';
  }

  // Calculate cart-wide tier summary
  // Tier por MONTO $ retail (cart.original_total_price) — alineado con
  // Shopify automatic discounts. Asi LIMA/cart/Shopify dan EL MISMO precio.
  function cartTierSummary(cart) {
    var totalPieces = 0;
    var totalPacks = 0;
    var totalCajas = 0;
    var suggestItem = null;
    var maxQty = 0;
    cart.items.forEach(function(item) {
      var info = detectItemPieces(item);
      var itemPieces = item.quantity * info.pieces;
      totalPieces += itemPieces;
      // Track highest-qty item for upgrade suggestion
      if (itemPieces > maxQty) {
        maxQty = itemPieces;
        suggestItem = item;
      }
      if (info.isCaja) {
        totalCajas += item.quantity;
        totalPacks += item.quantity * info.cajaPacks;
      } else if (info.ppu > 1) {
        // Pack product: qty = packs
        totalPacks += item.quantity;
        totalCajas += Math.floor(item.quantity / info.cajaPacks);
      } else if (detectGuantes(item)) {
        // Guantes: qty = pares (ppu=1, already counted in totalPieces)
        var paresPerCaja = GUANTES_PACK_SIZE * CAJA_PACKS;
        totalPacks += Math.floor(item.quantity / GUANTES_PACK_SIZE);
        totalCajas += Math.floor(item.quantity / paresPerCaja);
      }
    });
    // Subtotal retail en MXN (cart prices vienen en centavos)
    var subtotalCents = (typeof cart.original_total_price === 'number') ? cart.original_total_price : (cart.total_price || 0);
    var subtotalAmt = subtotalCents / 100;
    var tier = LimpiaCleanPricing.getTierForAmount(subtotalAmt);
    var nextTier = LimpiaCleanPricing.getNextTier(tier.key);
    var nextMsg = null;
    if (nextTier) {
      var hasAmt = typeof nextTier.minAmt === 'number';
      var amtNeeded = hasAmt ? Math.max(0, nextTier.minAmt - subtotalAmt) : 0;
      // Pieces "needed" = legacy field, ahora best-effort estimate (no se muestra como pieza)
      var neededPcs = hasAmt ? 0 : Math.max(0, nextTier.minQty - totalPieces);
      nextMsg = {
        needed: neededPcs,
        amtNeeded: amtNeeded,
        label: nextTier.label,
        icon: nextTier.icon,
        discount: nextTier.discountPercent
      };
    }
    return {
      totalPieces: totalPieces,
      totalPacks: totalPacks,
      totalCajas: totalCajas,
      subtotalAmt: subtotalAmt,
      tier: tier,
      nextTier: nextMsg,
      suggestItem: suggestItem
    };
  }

  function buildTierSummaryHTML(summary) {
    var html = '<div class="cart-tier-summary">';

    // Current tier badge
    html += '<div class="cart-tier-badge"><span class="badge badge-' + summary.tier.key + '">' + summary.tier.icon + ' ' + summary.tier.label + '</span>';
    if (summary.tier.discountPercent > 0) {
      html += ' <span style="color:var(--accent-600);font-weight:var(--font-bold)">-' + summary.tier.discountPercent + '% desc.</span>';
    }
    html += '</div>';

    // Detail line with totals
    var detailParts = [];
    detailParts.push(summary.totalPieces.toLocaleString() + ' piezas totales');
    if (summary.totalCajas > 0) detailParts.push(summary.totalCajas + (summary.totalCajas === 1 ? ' caja' : ' cajas'));
    html += '<div class="cart-tier-detail">📦 ' + detailParts.join(' · ') + '</div>';

    if (summary.nextTier) {
      var amtNeeded = summary.nextTier.amtNeeded || 0;
      var item = summary.suggestItem;

      // Show current vs next tier comparison
      html += '<div class="cart-tier-compare">';
      html += '<div class="cart-tier-compare-row">';
      html += '<span class="cart-tier-level-label">Actual:</span> <span class="badge badge-' + summary.tier.key + ' badge-sm">' + summary.tier.icon + ' ' + summary.tier.label + '</span>';
      if (summary.tier.discountPercent > 0) html += ' <span class="cart-tier-pct">-' + summary.tier.discountPercent + '%</span>';
      html += '</div>';
      html += '<div class="cart-tier-compare-arrow">↓</div>';
      html += '<div class="cart-tier-compare-row">';
      html += '<span class="cart-tier-level-label">Siguiente:</span> <span class="badge badge-' + summary.nextTier.icon.replace(/\s/g,'') + ' badge-sm">' + summary.nextTier.icon + ' ' + summary.nextTier.label + '</span>';
      html += ' <span class="cart-tier-pct cart-tier-pct-next">-' + summary.nextTier.discount + '%</span>';
      html += '</div>';
      html += '</div>';

      html += '<div class="cart-tier-next">💡 Te faltan <strong>' + LimpiaCleanPricing.formatMXN(amtNeeded) + '</strong> para nivel ' + summary.nextTier.icon + ' ' + summary.nextTier.label + '</div>';

      // Add upgrade button — adds more of the highest-qty product
      if (item && amtNeeded > 0) {
        var info = detectItemPieces(item);
        // item.original_price = precio retail por unidad de venta (caja/pack/pieza), en centavos
        var unitRetail = (typeof item.original_price === 'number' ? item.original_price : (item.price || 0)) / 100;
        var addQty;
        var addLabel;
        if (info.isCaja) {
          // Already buying cajas: cajas extra = ceil($faltante / $ por caja)
          var addCajas = unitRetail > 0 ? Math.max(1, Math.ceil(amtNeeded / unitRetail)) : 1;
          addQty = addCajas;
          addLabel = '+' + addCajas + (addCajas === 1 ? ' caja' : ' cajas') + ' ' + item.product_title.substring(0, 25);
        } else if (info.ppu > 1) {
          // Pack product: packs extra, redondeado a caja completa
          var addPacks = unitRetail > 0 ? Math.max(1, Math.ceil(amtNeeded / unitRetail)) : 1;
          addPacks = Math.ceil(addPacks / info.cajaPacks) * info.cajaPacks;
          addQty = addPacks;
          var addCajas = addPacks / info.cajaPacks;
          addLabel = '+' + addCajas + (addCajas === 1 ? ' caja' : ' cajas') + ' ' + item.product_title.substring(0, 25);
        } else if (detectGuantes(item)) {
          // Guantes: pares extra, redondeado a caja (72 pares)
          var paresPerCaja = GUANTES_PACK_SIZE * CAJA_PACKS;
          var addPares = unitRetail > 0 ? Math.max(1, Math.ceil(amtNeeded / unitRetail)) : paresPerCaja;
          addPares = Math.ceil(addPares / paresPerCaja) * paresPerCaja;
          addQty = addPares;
          var addCajas = addPares / paresPerCaja;
          addLabel = '+' + addCajas + (addCajas === 1 ? ' caja' : ' cajas') + ' ' + item.product_title.substring(0, 25);
        } else {
          addQty = unitRetail > 0 ? Math.max(1, Math.ceil(amtNeeded / unitRetail)) : 1;
          addLabel = '+' + addQty.toLocaleString() + ' ' + item.product_title.substring(0, 25);
        }
        html += '<button type="button" class="btn-tier-upgrade" onclick="LimpiaCleanCart.addItem(' + item.variant_id + ', ' + addQty + ')">';
        html += '🚀 ' + addLabel;
        html += '</button>';
      }
    } else {
      html += '<div class="cart-tier-max">🏆 Maximo nivel de descuento alcanzado</div>';
    }
    html += '</div>';
    return html;
  }

  function updateSidebar(cart) {
    var itemsContainer = document.getElementById('cart-items');
    var footer = document.getElementById('cart-footer');
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML =
        '<div class="cart-empty">' +
        '<div class="cart-empty-icon">🛒</div>' +
        '<p>Tu carrito esta vacio</p>' +
        '<a href="/collections/all" class="btn btn-primary" style="margin-top: var(--space-4);">Ver Catalogo</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }

    // Pre-calculate tier summary for per-item suggestions
    var summary = cartTierSummary(cart);
    var currentTier = summary.tier;
    var nextTierInfo = summary.nextTier;
    // Resolve the full next tier object for per-item suggestions
    var nextTierObj = nextTierInfo ? LimpiaCleanPricing.getNextTier(currentTier.key) : null;

    var html = '';
    cart.items.forEach(function(item, index) {
      var line = index + 1;
      var imgSrc = sidebarImgUrl(item.image);
      var variantText = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var breakdown = itemBreakdown(item);
      var suggestion = nextTierObj ? itemTierSuggestion(item, summary, currentTier, nextTierObj) : '';
      html +=
        '<div class="cart-item">' +
        '<div class="cart-item-image">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + (item.title || '') + '" width="64" height="64" loading="lazy">' : '<span style="font-size:2rem">🧴</span>') +
        '</div>' +
        '<div class="cart-item-details">' +
        '<div class="cart-item-name">' + item.product_title + '</div>' +
        (variantText ? '<div class="cart-item-variant">' + variantText + '</div>' : '') +
        (breakdown ? '<div class="cart-item-breakdown">' + breakdown + '</div>' : '') +
        '<div class="cart-item-qty-row">' +
        '<button type="button" class="cart-sidebar-qty-btn" onclick="LimpiaCleanCart.updateLine(' + line + ', ' + Math.max(0, item.quantity - 1) + ')" aria-label="Menos">−</button>' +
        '<span class="cart-sidebar-qty-val">' + item.quantity + '</span>' +
        '<button type="button" class="cart-sidebar-qty-btn" onclick="LimpiaCleanCart.updateLine(' + line + ', ' + (item.quantity + 1) + ')" aria-label="Mas">+</button>' +
        '</div>' +
        '<div class="cart-item-price">' + formatShopifyMoney(item.final_line_price) + '</div>' +
        '</div>' +
        '<button type="button" class="cart-item-remove" onclick="LimpiaCleanCart.updateLine(' + line + ', 0)" title="Eliminar" aria-label="Eliminar">&times;</button>' +
        '</div>' +
        suggestion;
    });

    // Tier summary at bottom of items
    html += buildTierSummaryHTML(summary);

    itemsContainer.innerHTML = html;

    // Async: populate alternative color/size suggestions
    populateAlternativeSuggestions();

    if (footer) {
      footer.style.display = 'block';
      var subtotalEl = document.getElementById('cart-subtotal');
      var totalEl = document.getElementById('cart-total');
      var discountLine = document.getElementById('cart-tier-discount-line');
      var totalLine = document.getElementById('cart-total-line');
      var whatsappQuote = document.getElementById('cart-whatsapp-quote');

      // Use original_total_price (before Shopify discounts) as subtotal
      var originalTotal = cart.original_total_price || cart.total_price;
      var shopifyDiscount = cart.total_discount || 0;
      var hasShopifyDiscount = shopifyDiscount > 0 && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;

      if (subtotalEl) subtotalEl.textContent = formatShopifyMoney(originalTotal);

      // Show Shopify's actual applied discount
      if (hasShopifyDiscount && discountLine) {
        var discountApp = cart.cart_level_discount_applications[0];
        var listPriceEl = document.getElementById('cart-list-price');
        var tierTotalEl = document.getElementById('cart-tier-total');
        var tierLabelEl = document.getElementById('cart-tier-label');

        if (listPriceEl) listPriceEl.textContent = formatShopifyMoney(originalTotal);
        if (tierTotalEl) tierTotalEl.textContent = formatShopifyMoney(cart.total_price);
        if (tierLabelEl) tierLabelEl.textContent = discountApp.title;
        discountLine.style.display = 'block';
        if (totalLine) totalLine.style.display = 'none';
        if (whatsappQuote) {
          // Build WhatsApp message with cart items
          var msg = 'Hola! Quiero confirmar mi pedido con descuento ' + discountApp.title + ':%0A';
          cart.items.forEach(function(item) {
            msg += '- ' + item.product_title + ' x' + item.quantity;
            if (item.variant_title && item.variant_title !== 'Default Title') msg += ' (' + item.variant_title + ')';
            msg += '%0A';
          });
          msg += '%0ASubtotal: ' + formatShopifyMoney(originalTotal);
          msg += '%0ADescuento ' + discountApp.title + ': -' + formatShopifyMoney(shopifyDiscount);
          msg += '%0ATotal: ' + formatShopifyMoney(cart.total_price);
          var waNum = (window.LimpiaClean && window.LimpiaClean.whatsappNumber) || '525550180617';
          whatsappQuote.href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(msg.replace(/%0A/g, '\n'));
          whatsappQuote.style.display = 'block';
        }
      } else {
        if (discountLine) discountLine.style.display = 'none';
        if (totalLine) totalLine.style.display = '';
        if (whatsappQuote) whatsappQuote.style.display = 'none';
      }

      if (totalEl) totalEl.textContent = formatShopifyMoney(cart.total_price);
    }
  }

  // Build per-item tier upgrade suggestion with smart color/size alternatives
  // El upsell se calcula por MONTO $ faltante (Shopify automatic discounts).
  // Antes era por piezas, lo que causaba el bug "Agrega 9 cajas para Oro" cuando
  // el cliente ya estaba en Oro (porque Oro se activa por $20K, no por 5K piezas).
  function itemTierSuggestion(item, summary, currentTier, nextTier) {
    if (!nextTier) return ''; // Already at max tier
    if (!summary || typeof summary !== 'object') return '';
    var info = detectItemPieces(item);
    var itemPiecesPerUnit = info.pieces; // pieces per 1 qty of this item
    if (itemPiecesPerUnit <= 0) return '';

    // amtNeeded en MXN para alcanzar el siguiente tier
    var amtNeeded = (summary.nextTier && typeof summary.nextTier.amtNeeded === 'number') ? summary.nextTier.amtNeeded : 0;
    if (amtNeeded <= 0) return '';

    // item.original_price = precio retail por unidad de venta (caja/pack/pieza), en centavos
    var unitRetail = (typeof item.original_price === 'number' ? item.original_price : (item.price || 0)) / 100;
    if (unitRetail <= 0) return '';

    // Cuantas unidades MAS de ESTE item para alcanzar el monto faltante?
    var addQty = Math.max(1, Math.ceil(amtNeeded / unitRetail));
    var addPcs = addQty * itemPiecesPerUnit;

    // Determine label based on product type
    var unitLabel;
    var suggestQtyPerColor = addQty; // qty to suggest for each color alternative
    if (info.isCaja) {
      unitLabel = addQty === 1 ? '1 caja' : addQty + ' cajas';
      suggestQtyPerColor = 1;
    } else if (info.ppu > 1) {
      if (addQty >= info.cajaPacks) {
        var addCajasCount = Math.ceil(addQty / info.cajaPacks);
        addQty = addCajasCount * info.cajaPacks;
        addPcs = addQty * itemPiecesPerUnit;
        unitLabel = addCajasCount === 1 ? '1 caja' : addCajasCount + ' cajas';
        suggestQtyPerColor = info.cajaPacks; // 1 caja worth per color
      } else {
        unitLabel = addQty === 1 ? '1 pack' : addQty + ' packs';
        suggestQtyPerColor = Math.min(addQty, info.cajaPacks);
      }
    } else if (detectGuantes(item)) {
      var paresPerCaja = GUANTES_PACK_SIZE * CAJA_PACKS;
      if (addQty >= paresPerCaja) {
        var gc = Math.ceil(addQty / paresPerCaja);
        addQty = gc * paresPerCaja;
        addPcs = addQty;
        unitLabel = gc === 1 ? '1 caja' : gc + ' cajas';
        suggestQtyPerColor = paresPerCaja;
      } else if (addQty >= GUANTES_PACK_SIZE) {
        var gp = Math.ceil(addQty / GUANTES_PACK_SIZE);
        addQty = gp * GUANTES_PACK_SIZE;
        addPcs = addQty;
        unitLabel = gp === 1 ? '1 pack' : gp + ' packs';
        suggestQtyPerColor = GUANTES_PACK_SIZE;
      } else {
        unitLabel = addQty + ' pares';
        suggestQtyPerColor = addQty;
      }
    } else {
      unitLabel = addQty === 1 ? '1 pieza' : addQty.toLocaleString() + ' piezas';
      suggestQtyPerColor = Math.min(addQty, 10);
    }

    var nextDiscount = nextTier.discountPercent;
    var amtNeededLabel = LimpiaCleanPricing.formatMXN(amtNeeded);

    var html = '<div class="cart-item-tier-suggest">';
    html += '<div class="cart-item-tier-suggest-text">';
    html += '💡 Agrega <strong>' + unitLabel + '</strong> (' + amtNeededLabel + ' mas) para ';
    html += '<span class="badge badge-' + nextTier.key + ' badge-xs">' + nextTier.icon + ' ' + nextTier.label + '</span>';
    html += ' <strong>-' + nextDiscount + '%</strong>';
    html += '</div>';

    // Main upgrade button (same variant)
    html += '<button type="button" class="btn-item-tier-upgrade" onclick="LimpiaCleanCart.addItem(' + item.variant_id + ', ' + addQty + ')">';
    html += '⬆️ +' + unitLabel + ' (mismo)';
    html += '</button>';

    // Placeholder for alternative color/size suggestions (populated async)
    // data-needed conserva el numero de piezas (compat con populateAlternativeSuggestions)
    html += '<div class="cart-item-alt-suggestions" data-handle="' + (item.handle || '') + '" data-variant-id="' + item.variant_id + '" data-needed="' + addPcs + '" data-suggest-qty="' + suggestQtyPerColor + '"></div>';

    // Link to product page for more options
    if (item.url) {
      html += '<a href="' + item.url + '" class="cart-item-more-link">Ver mas colores y medidas →</a>';
    }

    html += '</div>';
    return html;
  }

  // Fetch product data for alternative variant suggestions
  var _productCache = {};
  async function fetchProductData(handle) {
    if (!handle) return null;
    if (_productCache[handle]) return _productCache[handle];
    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      var data = await res.json();
      _productCache[handle] = data;
      return data;
    } catch(e) { return null; }
  }

  // Populate alternative color/size suggestions after sidebar render
  async function populateAlternativeSuggestions() {
    var containers = document.querySelectorAll('.cart-item-alt-suggestions[data-handle]');
    if (!containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      var handle = el.getAttribute('data-handle');
      if (!handle) continue;

      var productData = await fetchProductData(handle);
      if (!productData || !productData.variants || productData.variants.length < 2) continue;

      var currentVariantId = parseInt(el.getAttribute('data-variant-id'));
      var suggestQty = parseInt(el.getAttribute('data-suggest-qty')) || 1;
      var neededPcs = parseInt(el.getAttribute('data-needed')) || 0;

      var altHtml = buildAlternativeButtons(productData, currentVariantId, suggestQty, neededPcs);
      if (altHtml) el.innerHTML = altHtml;
    }
  }

  // Build quick-add buttons for alternative colors/sizes of same product
  function buildAlternativeButtons(productData, currentVariantId, suggestQty, neededPcs) {
    var currentVariant = null;
    productData.variants.forEach(function(v) {
      if (v.id === currentVariantId) currentVariant = v;
    });
    if (!currentVariant) return '';

    // Parse product options to identify Color and Empaque/Size
    // Shopify /products/{handle}.js returns options as [{name:"Color",position:1,values:[...]}, ...]
    var colorOptIndex = -1;
    var empaqueOptIndex = -1;
    var sizeOptIndex = -1;
    (productData.options || []).forEach(function(opt, idx) {
      var optName = (typeof opt === 'string') ? opt : (opt.name || opt.toString());
      var lo = optName.toLowerCase();
      if (lo === 'color') colorOptIndex = idx;
      else if (lo === 'empaque' || lo === 'presentacion' || lo === 'tipo') empaqueOptIndex = idx;
      else if (lo === 'talla' || lo === 'medida' || lo === 'tamaño' || lo === 'size') sizeOptIndex = idx;
    });

    var currentOpts = [];
    if (currentVariant.option1) currentOpts.push(currentVariant.option1);
    if (currentVariant.option2) currentOpts.push(currentVariant.option2);
    if (currentVariant.option3) currentOpts.push(currentVariant.option3);

    var currentColor = colorOptIndex >= 0 ? (currentOpts[colorOptIndex] || '') : '';
    var currentEmpaque = empaqueOptIndex >= 0 ? (currentOpts[empaqueOptIndex] || '') : '';

    // Collect alternatives: same empaque, different color
    var altColors = [];
    // Collect alternatives: same color, different empaque/size
    var altSizes = [];
    // Track already-suggested variant IDs
    var seen = {};

    productData.variants.forEach(function(v) {
      if (v.id === currentVariantId || !v.available) return;
      var opts = [];
      if (v.option1) opts.push(v.option1);
      if (v.option2) opts.push(v.option2);
      if (v.option3) opts.push(v.option3);

      var vColor = colorOptIndex >= 0 ? (opts[colorOptIndex] || '') : '';
      var vEmpaque = empaqueOptIndex >= 0 ? (opts[empaqueOptIndex] || '') : '';

      // Same empaque, different color → suggest adding this color
      if (colorOptIndex >= 0 && vColor !== currentColor) {
        if (empaqueOptIndex < 0 || vEmpaque === currentEmpaque) {
          if (!seen[v.id]) {
            altColors.push({ id: v.id, color: vColor, empaque: vEmpaque, title: v.title, price: v.price });
            seen[v.id] = true;
          }
        }
      }

      // Same color, different empaque → suggest upgrading empaque (e.g., pack → caja)
      if (empaqueOptIndex >= 0 && vColor === currentColor && vEmpaque !== currentEmpaque) {
        var vEmpLo = vEmpaque.toLowerCase();
        // Only suggest "upgrade" empaques (caja over pack, pack over individual)
        if (vEmpLo.indexOf('caja') >= 0) {
          if (!seen[v.id]) {
            altSizes.push({ id: v.id, color: vColor, empaque: vEmpaque, title: v.title, price: v.price, priority: 1 });
            seen[v.id] = true;
          }
        }
      }
    });

    if (altColors.length === 0 && altSizes.length === 0) return '';

    var html = '';

    // Alternative colors section
    if (altColors.length > 0) {
      html += '<div class="cart-alt-section">';
      html += '<span class="cart-alt-label">🎨 Combina colores:</span>';
      html += '<div class="cart-alt-btns">';
      altColors.slice(0, 4).forEach(function(alt) {
        var colorClass = alt.color.toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-').replace(/--/g, '-');
        var pcsLabel = suggestQty > 1 ? ' (+' + suggestQty + ')' : '';
        html += '<button type="button" class="btn-alt-variant" onclick="LimpiaCleanCart.addItem(' + alt.id + ', ' + suggestQty + ')" title="Agregar ' + suggestQty + ' ' + alt.color + '">';
        html += '<span class="color-dot color-dot-' + colorClass + '" style="width:14px;height:14px;"></span>';
        html += '<span>' + alt.color + pcsLabel + '</span>';
        html += '</button>';
      });
      html += '</div></div>';
    }

    // Alternative empaque/size section
    if (altSizes.length > 0) {
      html += '<div class="cart-alt-section">';
      html += '<span class="cart-alt-label">📦 Otra presentacion:</span>';
      html += '<div class="cart-alt-btns">';
      altSizes.slice(0, 3).forEach(function(alt) {
        html += '<button type="button" class="btn-alt-variant btn-alt-size" onclick="LimpiaCleanCart.addItem(' + alt.id + ', 1)" title="Agregar 1 ' + alt.empaque + '">';
        html += '<span>+1 ' + alt.empaque + '</span>';
        html += '</button>';
      });
      html += '</div></div>';
    }

    return html;
  }

  function formatShopifyMoney(cents) {
    var n = (typeof cents === 'number' && isFinite(cents)) ? cents / 100 : 0;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  return { toggle, open, close, fetchCart, addItem, updateLine, refreshUI };
})();


/* --- PRODUCT PAGE --- */
const LimpiaCleanProduct = (function() {
  var config = null;
  var currentQty = 1;
  var unitSingular = 'pieza';
  var unitPlural = 'piezas';
  var unitAbbr = 'pz';
  var packSize = 1;
  var cajaPacks = 6;
  var cajaSize = 1;
  var piecesPerUnit = 1;
  var hasMultipleColors = false;
  // Empaque variant pricing (works for ALL product types)
  var packPrice = 0;         // Price per PACK variant
  var cajaPrice = 0;         // Price per CAJA variant
  var individualPrice = 0;   // Price per INDIVIDUAL variant
  var cajaVariantId = null;
  var currentEmpaque = 'pack'; // 'pack', 'caja', or 'individual'
  var piecesPerCaja = 0;
  var hasEmpaqueVariants = false;
  var cajaByColor = {};
  var packByColor = {};
  var individualByColor = {};

  function init(productConfig) {
    config = productConfig;
    currentQty = 1;
    unitSingular = config.unitSingular || 'pieza';
    unitPlural = config.unitPlural || 'piezas';
    unitAbbr = getUnitAbbr(unitPlural);
    packSize = config.packSize || 1;
    cajaPacks = config.cajaPacks || 6;
    cajaSize = packSize * cajaPacks;
    piecesPerUnit = config.piecesPerUnit || 1;
    hasMultipleColors = config.hasMultipleColors || false;
    // For pack products (50 Pack, etc), adjust unit labels
    if (piecesPerUnit > 1) {
      unitSingular = 'pack';
      unitPlural = 'packs';
      unitAbbr = 'pack';
    }

    // Detect empaque variants (Individual/Pack/Caja) for ALL product types
    packPrice = 0;
    cajaPrice = 0;
    individualPrice = 0;
    cajaVariantId = null;
    cajaByColor = {};
    packByColor = {};
    individualByColor = {};
    hasEmpaqueVariants = false;
    currentEmpaque = piecesPerUnit > 1 ? 'pack' : 'individual';

    var directCajaSize = 0; // For "CAJA CON 40 PZS" style (direct piece count, no pack sub-structure)

    if (config.variants && config.variants.length > 1) {
      config.variants.forEach(function(v) {
        var vtitle = (v.title || '').toLowerCase();
        var color = (v.option1 || 'default').toLowerCase();
        var vp = (typeof v.price === 'string' ? parseFloat(v.price) : v.price) / 100;

        if (vtitle.indexOf('caja') >= 0) {
          hasEmpaqueVariants = true;
          cajaByColor[color] = { id: v.id, price: vp };
          // Pattern A: "3 pack de 8" or "6 paquetes de 50" (pack sub-structure)
          var m = vtitle.match(/(\d+)\s*(paquete|pack)/i);
          if (m) cajaPacks = parseInt(m[1]);
          // Also detect pieces per pack from caja title: "pack de 8"
          var m2 = vtitle.match(/(?:pack|paquete)\s*(?:de|con)?\s*(\d+)/i);
          if (m2 && piecesPerUnit <= 1) {
            var detPkSize = parseInt(m2[1]);
            if (detPkSize > 1) packSize = detPkSize;
          }
          // Pattern B: "CAJA CON 40 PZS" (direct piece count, no pack sub-structure)
          if (!m) {
            var m3 = vtitle.match(/(?:con|de)\s*(\d+)\s*(?:pz|pieza|par|unid)/i);
            if (m3) directCajaSize = parseInt(m3[1]);
          }
        } else if (vtitle.indexOf('pack') >= 0 || vtitle.indexOf('paquete') >= 0) {
          hasEmpaqueVariants = true;
          packByColor[color] = { id: v.id, price: vp };
          // "pack con 8 piezas" or "paquete con 10 piezas" or "8 piezas"
          var m = vtitle.match(/(\d+)\s*(pieza|pz|par|unid)/i);
          if (m && piecesPerUnit <= 1) {
            var detPkSize = parseInt(m[1]);
            if (detPkSize > 1) packSize = detPkSize;
          }
          if (!m) {
            var m2 = vtitle.match(/(?:pack|paquete)\s*(?:con|de)?\s*(\d+)/i);
            if (m2 && piecesPerUnit <= 1) {
              var detPkSize = parseInt(m2[1]);
              if (detPkSize > 1) packSize = detPkSize;
            }
          }
        } else {
          // Individual/default variant (no "pack" or "caja" in title)
          individualByColor[color] = { id: v.id, price: vp };
          // For piecesPerUnit > 1 products, "individual" IS the pack
          if (piecesPerUnit > 1) {
            packByColor[color] = { id: v.id, price: vp };
          }
        }
      });

      // Recalculate derived sizes
      var hasPackVariant = Object.keys(packByColor).length > 0;
      if (directCajaSize > 1) {
        // Caja size specified directly in variant title (e.g. "CAJA CON 40 PZS")
        cajaSize = directCajaSize;
        if (hasPackVariant && packSize > 1) {
          cajaPacks = Math.max(1, Math.round(cajaSize / packSize));
        } else {
          cajaPacks = 1; // No pack sub-structure
        }
      } else {
        cajaSize = packSize * cajaPacks;
      }
      piecesPerCaja = piecesPerUnit > 1 ? (cajaPacks * piecesPerUnit) : cajaSize;

      // Set prices from first available color
      var fc = Object.keys(individualByColor)[0];
      if (fc) individualPrice = individualByColor[fc].price;
      fc = Object.keys(packByColor)[0];
      if (fc) packPrice = packByColor[fc].price;
      fc = Object.keys(cajaByColor)[0];
      if (fc) {
        cajaPrice = cajaByColor[fc].price;
        cajaVariantId = cajaByColor[fc].id;
      }

      // For non-pack products: config.price should be INDIVIDUAL price (not caja/pack)
      if (piecesPerUnit <= 1 && individualPrice > 0) {
        config.price = individualPrice;
      }
      // For pack products: config.price should be pack price
      if (piecesPerUnit > 1 && packPrice > 0) {
        config.price = packPrice;
      }

      // Detect current empaque from selected variant
      config.variants.forEach(function(v) {
        if (v.id == config.variantId) {
          var vtitle = (v.title || '').toLowerCase();
          if (vtitle.indexOf('caja') >= 0) {
            currentEmpaque = 'caja';
          } else if (vtitle.indexOf('pack') >= 0 || vtitle.indexOf('paquete') >= 0) {
            currentEmpaque = 'pack';
          } else {
            currentEmpaque = piecesPerUnit > 1 ? 'pack' : 'individual';
          }
        }
      });

      // If no individual variant exists but pack does, default to pack empaque
      if (currentEmpaque === 'individual' && individualPrice <= 0 && packPrice > 0) {
        currentEmpaque = 'pack';
        config.price = packPrice;
      }
    } else {
      // Single variant or no variants
      piecesPerCaja = piecesPerUnit > 1 ? (cajaPacks * piecesPerUnit) : (packSize * cajaPacks);
      packPrice = config.price;
    }

    buildQuickAddButtons();
    buildTierTable();
    recalculate();

    // Intercept the add-to-cart form
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && !form._cartIntercepted) {
      form._cartIntercepted = true;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var variantId = document.getElementById('product-variant-id').value;
        var qty = parseInt(document.getElementById('product-qty').value) || 1;
        LimpiaCleanCart.addItem(parseInt(variantId), qty);
      });
    }
  }

  function getUnitAbbr(plural) {
    if (plural === 'piezas') return 'pz';
    if (plural === 'pares') return 'par';
    if (plural === 'unidades') return 'ud';
    return plural.substring(0, 3);
  }

  function changeQty(delta) {
    var input = document.getElementById('product-qty');
    var newQty = Math.max(1, parseInt(input.value || 1) + delta);
    input.value = newQty;
    currentQty = newQty;
    document.getElementById('form-qty').value = newQty;
    recalculate();
  }

  function recalculate() {
    if (!config) return;
    var input = document.getElementById('product-qty');
    currentQty = parseInt(input.value || 1);

    // Calculate total pieces based on product type and empaque
    var totalPieces, basePrice, unitLabel;
    if (piecesPerUnit > 1 && currentEmpaque === 'caja' && cajaPrice > 0) {
      totalPieces = currentQty * piecesPerCaja;
      basePrice = cajaPrice;
      unitLabel = 'caja';
    } else if (piecesPerUnit > 1) {
      totalPieces = currentQty * piecesPerUnit;
      basePrice = packPrice > 0 ? packPrice : config.price;
      unitLabel = 'pack';
    } else if (hasEmpaqueVariants && currentEmpaque === 'caja' && cajaPrice > 0) {
      totalPieces = currentQty * cajaSize;
      basePrice = cajaPrice;
      unitLabel = 'caja';
    } else if (hasEmpaqueVariants && currentEmpaque === 'pack' && packPrice > 0) {
      totalPieces = currentQty * packSize;
      basePrice = packPrice;
      unitLabel = 'pack';
    } else {
      totalPieces = currentQty;
      basePrice = individualPrice > 0 ? individualPrice : config.price;
      unitLabel = unitAbbr;
    }

    var retailTotal = basePrice * currentQty;
    // Tier por monto $ (retail subtotal) — alineado con Shopify automatic discounts
    var tier = LimpiaCleanPricing.getTierForAmount(retailTotal);
    var unitPrice = basePrice * tier.multiplier;
    var total = unitPrice * currentQty;
    var savings = retailTotal - total;
    var nextTier = LimpiaCleanPricing.getNextTier(tier.key);
    var nextTierMsg = null;
    if (nextTier) {
      var hasAmt = typeof nextTier.minAmt === 'number';
      var amtNeeded = hasAmt ? Math.max(0, nextTier.minAmt - retailTotal) : 0;
      // Piezas equivalentes (ceil) para alcanzar el siguiente tier
      var neededPieces = hasAmt
        ? (basePrice > 0 ? Math.ceil(amtNeeded / basePrice) * (totalPieces / Math.max(1, currentQty)) : 0)
        : Math.max(0, nextTier.minQty - totalPieces);
      if (amtNeeded > 0 || neededPieces > 0) {
        nextTierMsg = {
          needed: neededPieces,
          amtNeeded: amtNeeded,
          tierLabel: nextTier.label,
          tierIcon: nextTier.icon,
          unitPrice: basePrice * nextTier.multiplier
        };
      }
    }

    // Update price display
    var priceEl = document.getElementById('product-price');
    var perUnitEl = document.getElementById('price-per-unit');
    var currencyEl = document.getElementById('price-currency');
    var fmt = LimpiaCleanPricing.formatMXN;

    if (piecesPerUnit > 1) {
      // Hide MXN label — we show /pza in the price itself
      if (currencyEl) currencyEl.style.display = 'none';
      // PACK PRODUCT: main price = PER PIEZA (what the customer actually pays per piece)
      var perPiece, perPack, perCaja, qtyLine;

      if (currentEmpaque === 'caja' && cajaPrice > 0) {
        perCaja = unitPrice;
        perPack = perCaja / cajaPacks;
        perPiece = perCaja / piecesPerCaja;
        qtyLine = currentQty + (currentQty === 1 ? ' caja' : ' cajas')
          + ' = ' + (currentQty * cajaPacks) + ' packs'
          + ' = ' + totalPieces.toLocaleString() + ' piezas';
      } else {
        perPack = unitPrice;
        perPiece = perPack / piecesPerUnit;
        perCaja = cajaPrice > 0 ? (cajaPrice * tier.multiplier) : (perPack * cajaPacks);
        var numCajas = Math.floor(currentQty / cajaPacks);
        var remainPacks = currentQty % cajaPacks;
        if (currentQty === 1) {
          qtyLine = '1 pack = ' + piecesPerUnit + ' piezas';
        } else if (numCajas > 0 && remainPacks === 0) {
          qtyLine = numCajas + (numCajas === 1 ? ' caja' : ' cajas')
            + ' = ' + currentQty + ' packs = ' + totalPieces.toLocaleString() + ' piezas';
        } else if (numCajas > 0) {
          qtyLine = numCajas + (numCajas === 1 ? ' caja' : ' cajas')
            + ' + ' + remainPacks + (remainPacks === 1 ? ' pack' : ' packs')
            + ' = ' + totalPieces.toLocaleString() + ' piezas';
        } else {
          qtyLine = currentQty + ' packs = ' + totalPieces.toLocaleString() + ' piezas';
        }
      }

      // MAIN PRICE = per pieza (hero price)
      if (priceEl) {
        priceEl.innerHTML = fmt(perPiece) + '<span style="font-size:var(--text-lg);font-weight:var(--font-semibold);color:var(--neutral-500)">/pza</span>';
      }

      // Breakdown: total + per pack/caja + qty summary
      if (perUnitEl) {
        var breakdownHTML = '<div style="display:flex;flex-direction:column;gap:4px">';
        breakdownHTML += '<div style="font-size:var(--text-lg);font-weight:var(--font-bold);color:var(--neutral-800)">Total: ' + fmt(total) + '</div>';
        breakdownHTML += '<div style="font-weight:var(--font-semibold)">' + fmt(perPack) + '/pack · ' + fmt(perCaja) + '/caja</div>';
        breakdownHTML += '<div style="color:var(--neutral-500);font-size:var(--text-sm)">' + qtyLine + '</div>';
        breakdownHTML += '</div>';
        perUnitEl.innerHTML = breakdownHTML;
      }
    } else if (packSize > 1 || hasEmpaqueVariants) {
        // Products with empaque variants (Individual/Pack/Caja) or packSize > 1
        if (currencyEl) currencyEl.style.display = 'none';

        // Calculate per-pieza price using actual variant prices
        var perPiece, perPack, perCaja, qtyLine;
        var indvPrice = individualPrice > 0 ? individualPrice : config.price;

        if (hasEmpaqueVariants && currentEmpaque === 'caja' && cajaPrice > 0) {
          // Caja variant selected: basePrice = cajaPrice, qty in cajas
          perCaja = unitPrice; // cajaPrice * tier.mult
          perPack = (packPrice > 0 && cajaPacks > 1) ? perCaja / cajaPacks : 0;
          perPiece = perCaja / cajaSize;
          if (packPrice > 0 && cajaPacks > 1) {
            qtyLine = currentQty + (currentQty === 1 ? ' caja' : ' cajas')
              + ' (' + (currentQty * cajaPacks) + ' packs / ' + totalPieces + ' ' + unitPlural + ')';
          } else {
            qtyLine = currentQty + (currentQty === 1 ? ' caja' : ' cajas')
              + ' (' + totalPieces + ' ' + unitPlural + ')';
          }
        } else if (hasEmpaqueVariants && currentEmpaque === 'pack' && packPrice > 0) {
          // Pack variant selected: basePrice = packPrice, qty in packs
          perPack = unitPrice; // packPrice * tier.mult
          perPiece = perPack / packSize;
          perCaja = cajaPrice > 0 ? (cajaPrice * tier.multiplier) : (perPack * cajaPacks);
          qtyLine = currentQty + (currentQty === 1 ? ' pack' : ' packs')
            + ' (' + totalPieces + ' ' + unitPlural + ')';
        } else {
          // Individual: use per-unit prices calculated from variants
          perPiece = indvPrice * tier.multiplier;
          perPack = packPrice > 0 ? (packPrice * tier.multiplier) : 0;
          perCaja = cajaPrice > 0 ? (cajaPrice * tier.multiplier) : (perPack > 0 ? perPack * cajaPacks : 0);
          qtyLine = currentQty + ' ' + (currentQty === 1 ? unitSingular : unitPlural);
          // Add breakdown for multi-unit quantities
          if (packPrice > 0 && packSize > 1) {
            var numPacks = Math.floor(currentQty / packSize);
            var remainUnits = currentQty % packSize;
            var numCajas = Math.floor(currentQty / cajaSize);
            if (numCajas > 0) {
              var remainAfterCajas = currentQty % cajaSize;
              var remainPksCajas = Math.floor(remainAfterCajas / packSize);
              var remainUnitsPks = remainAfterCajas % packSize;
              var parts = [numCajas + (numCajas === 1 ? ' caja' : ' cajas')];
              if (remainPksCajas > 0) parts.push(remainPksCajas + (remainPksCajas === 1 ? ' pack' : ' packs'));
              if (remainUnitsPks > 0) parts.push(remainUnitsPks + ' ' + unitPlural);
              qtyLine += ' = ' + parts.join(' + ');
            } else if (numPacks > 0) {
              var parts = [numPacks + (numPacks === 1 ? ' pack' : ' packs')];
              if (remainUnits > 0) parts.push(remainUnits + ' ' + unitPlural);
              qtyLine += ' = ' + parts.join(' + ');
            }
          } else if (cajaSize > 1) {
            // No pack variant but has caja — show caja breakdown only
            var numCajas = Math.floor(currentQty / cajaSize);
            if (numCajas > 0) {
              var remainAfterCajas = currentQty % cajaSize;
              var parts = [numCajas + (numCajas === 1 ? ' caja' : ' cajas')];
              if (remainAfterCajas > 0) parts.push(remainAfterCajas + ' ' + unitPlural);
              qtyLine += ' = ' + parts.join(' + ');
            }
          }
        }

        // Main price = per pieza
        if (priceEl) {
          priceEl.innerHTML = fmt(perPiece) + '<span style="font-size:var(--text-lg);font-weight:var(--font-semibold);color:var(--neutral-500)">/' + unitAbbr + '</span>';
        }

        if (perUnitEl) {
          var breakdownHTML = '<div style="display:flex;flex-direction:column;gap:4px">';
          breakdownHTML += '<div style="font-size:var(--text-lg);font-weight:var(--font-bold);color:var(--neutral-800)">Total: ' + fmt(total) + '</div>';
          if (perPack > 0 && packPrice > 0) {
            breakdownHTML += '<div style="font-weight:var(--font-semibold)">' + fmt(perPack) + '/pack (' + packSize + ' ' + unitPlural + ') · ' + fmt(perCaja) + '/caja (' + cajaSize + ' ' + unitPlural + ')</div>';
          } else if (perCaja > 0) {
            breakdownHTML += '<div style="font-weight:var(--font-semibold)">' + fmt(perCaja) + '/caja (' + cajaSize + ' ' + unitPlural + ')</div>';
          }
          breakdownHTML += '<div style="color:var(--neutral-500);font-size:var(--text-sm)">' + qtyLine + '</div>';
          breakdownHTML += '</div>';
          perUnitEl.innerHTML = breakdownHTML;
        }
    } else {
        // Simple product (packSize == 1): main price = per unit
        if (currencyEl) currencyEl.style.display = '';
        if (priceEl) priceEl.textContent = fmt(unitPrice);
        if (perUnitEl) {
          if (currentQty > 1) {
            perUnitEl.innerHTML = '<div style="font-size:var(--text-lg);font-weight:var(--font-bold);color:var(--neutral-800)">Total: ' + fmt(total) + '</div>'
              + '<div style="color:var(--neutral-500);font-size:var(--text-sm)">' + fmt(unitPrice) + '/' + unitAbbr + ' × ' + currentQty + '</div>';
          } else {
            perUnitEl.textContent = fmt(unitPrice) + ' por ' + unitSingular;
          }
        }
      }

    // Tier badge
    var badgeEl = document.getElementById('product-tier-badge');
    if (badgeEl) {
      badgeEl.className = 'badge badge-' + tier.key;
      badgeEl.textContent = tier.icon + ' ' + tier.label;
    }

    // Savings banner
    var savingsBanner = document.getElementById('savings-banner');
    var savingsText = document.getElementById('savings-text');
    if (savingsBanner && savingsText) {
      if (savings > 0) {
        savingsBanner.style.display = 'flex';
        savingsText.textContent = 'Ahorras ' + LimpiaCleanPricing.formatMXN(savings) + ' con nivel ' + tier.label;
      } else {
        savingsBanner.style.display = 'none';
      }
    }

    // Next tier hint — with upgrade button
    var hintEl = document.getElementById('next-tier-hint');
    var hintText = document.getElementById('next-tier-text');
    if (hintEl && hintText) {
      if (nextTierMsg) {
        hintEl.style.display = 'block';
        var fmt = LimpiaCleanPricing.formatMXN;

        // Calculate target qty and empaque for next tier
        // BY-AMOUNT: target = monto $ del siguiente tier / precio retail por unidad
        var targetQty, targetEmpaque, targetPriceLabel, upgradeLabel, neededLabel;
        var nextMinAmt = (typeof nextTier.minAmt === 'number') ? nextTier.minAmt : null;
        // Helper: cuantas unidades a precio retail por unidad para llegar al monto
        var qtyForAmount = function(retailPerUnit) {
          if (nextMinAmt === null) return null;
          return retailPerUnit > 0 ? Math.max(1, Math.ceil(nextMinAmt / retailPerUnit)) : 0;
        };

        if (piecesPerUnit > 1 && cajaPrice > 0) {
          // Pack product with Caja variant — always suggest in cajas
          var targetCajas = (nextMinAmt !== null)
            ? qtyForAmount(cajaPrice)
            : Math.ceil(nextTier.minQty / piecesPerCaja);
          targetQty = targetCajas;
          targetEmpaque = 'caja';
          var nextCajaPrice = cajaPrice * nextTier.multiplier;
          var nextPerPieza = nextCajaPrice / piecesPerCaja;
          targetPriceLabel = fmt(nextPerPieza) + '/pza · ' + fmt(nextCajaPrice) + '/caja';
          var neededCajas = Math.max(0, targetCajas - (currentEmpaque === 'caja' ? currentQty : 0));
          neededLabel = neededCajas + (neededCajas === 1 ? ' caja' : ' cajas') + ' (' + (neededCajas * piecesPerCaja).toLocaleString() + ' pzs)';
          upgradeLabel = targetCajas + (targetCajas === 1 ? ' caja' : ' cajas');
        } else if (piecesPerUnit > 1) {
          // Pack product without Caja variant — suggest in packs/cajas
          var targetPacks = (nextMinAmt !== null)
            ? qtyForAmount(packPrice)
            : Math.ceil(nextTier.minQty / piecesPerUnit);
          targetPacks = Math.ceil(targetPacks / cajaPacks) * cajaPacks;
          targetQty = targetPacks;
          targetEmpaque = 'pack';
          var nextPackPrice = packPrice * nextTier.multiplier;
          targetPriceLabel = fmt(nextPackPrice / piecesPerUnit) + '/pza · ' + fmt(nextPackPrice) + '/pack';
          var neededPacks = Math.max(0, targetPacks - currentQty);
          var neededCajas = Math.ceil(neededPacks / cajaPacks);
          neededLabel = neededPacks + ' packs (' + neededCajas + (neededCajas === 1 ? ' caja' : ' cajas') + ')';
          upgradeLabel = targetPacks + ' packs';
        } else if ((packSize > 1 || hasEmpaqueVariants) && cajaSize > 1) {
          if (hasEmpaqueVariants && cajaPrice > 0) {
            // Use actual Caja variant price
            var targetCajas = (nextMinAmt !== null)
              ? qtyForAmount(cajaPrice)
              : Math.ceil(nextTier.minQty / cajaSize);
            targetQty = targetCajas;
            targetEmpaque = 'caja';
            var nextCajaPrice = cajaPrice * nextTier.multiplier;
            var nextPerPieza = nextCajaPrice / cajaSize;
            targetPriceLabel = fmt(nextPerPieza) + '/' + unitAbbr + ' · ' + fmt(nextCajaPrice) + '/caja';
            var neededCajas = Math.max(0, targetCajas - (currentEmpaque === 'caja' ? currentQty : 0));
            neededLabel = neededCajas + (neededCajas === 1 ? ' caja' : ' cajas') + ' (' + (neededCajas * cajaSize).toLocaleString() + ' ' + unitPlural + ')';
            upgradeLabel = targetCajas + (targetCajas === 1 ? ' caja' : ' cajas');
          } else {
            var unitRetail = config.price || 0;
            var targetUnits = (nextMinAmt !== null && unitRetail > 0)
              ? Math.ceil(qtyForAmount(unitRetail) / cajaSize) * cajaSize
              : Math.ceil(nextTier.minQty / cajaSize) * cajaSize;
            targetQty = targetUnits;
            targetEmpaque = null;
            targetPriceLabel = fmt(unitRetail * nextTier.multiplier) + '/' + unitAbbr;
            var neededUnits = Math.max(0, targetUnits - currentQty);
            var neededCajas = Math.ceil(neededUnits / cajaSize);
            neededLabel = neededUnits.toLocaleString() + ' ' + unitPlural + ' (' + neededCajas + (neededCajas === 1 ? ' caja' : ' cajas') + ')';
            upgradeLabel = targetUnits.toLocaleString() + ' ' + unitPlural;
          }
        } else {
          var unitRetail = config.price || 0;
          targetQty = (nextMinAmt !== null) ? qtyForAmount(unitRetail) : nextTier.minQty;
          targetEmpaque = null;
          targetPriceLabel = fmt(unitRetail * nextTier.multiplier) + '/' + unitAbbr;
          var neededUnits = Math.max(0, targetQty - currentQty);
          neededLabel = neededUnits.toLocaleString() + ' ' + unitPlural;
          upgradeLabel = targetQty.toLocaleString() + ' ' + unitPlural;
        }

        var currentSavings = tier.discountPercent > 0 ? ' (-' + tier.discountPercent + '%)' : '';
        var currentPriceLabel;
        if (piecesPerUnit > 1) {
          currentPriceLabel = fmt(unitPrice / (currentEmpaque === 'caja' ? piecesPerCaja : piecesPerUnit)) + '/pza';
        } else if (hasEmpaqueVariants) {
          var perPz = currentEmpaque === 'caja' ? unitPrice / cajaSize : (currentEmpaque === 'pack' ? unitPrice / packSize : unitPrice);
          currentPriceLabel = fmt(perPz) + '/' + unitAbbr;
        } else {
          currentPriceLabel = fmt(unitPrice) + '/' + unitAbbr;
        }
        var onclickUpgrade = targetEmpaque
          ? 'LimpiaCleanProduct.setQty(' + targetQty + ',\'' + targetEmpaque + '\')'
          : 'LimpiaCleanProduct.setQty(' + targetQty + ')';

        hintText.innerHTML =
          '<div class="tier-upgrade-info">' +
          '<div class="tier-upgrade-current">Actual: <strong>' + tier.icon + ' ' + tier.label + currentSavings + '</strong> · ' + currentPriceLabel + '</div>' +
          '<div class="tier-upgrade-arrow">⬇</div>' +
          '<div class="tier-upgrade-next">Siguiente: <strong>' + nextTier.icon + ' ' + nextTier.label + ' (-' + nextTier.discountPercent + '%)</strong> · ' + targetPriceLabel + '</div>' +
          '<div class="tier-upgrade-needed">Agrega <strong>' + neededLabel + '</strong> mas</div>' +
          '<button type="button" class="btn-tier-upgrade" onclick="' + onclickUpgrade + '">' +
          '🚀 Subir a ' + nextTier.icon + ' ' + nextTier.label + ' (' + upgradeLabel + ')' +
          '</button>' +
          '</div>';
      } else {
        hintEl.style.display = 'block';
        var maxPriceLabel;
        if (piecesPerUnit > 1) {
          maxPriceLabel = LimpiaCleanPricing.formatMXN(unitPrice / (currentEmpaque === 'caja' ? piecesPerCaja : piecesPerUnit)) + '/pza';
        } else if (hasEmpaqueVariants) {
          var perPzMax = currentEmpaque === 'caja' ? unitPrice / cajaSize : (currentEmpaque === 'pack' ? unitPrice / packSize : unitPrice);
          maxPriceLabel = LimpiaCleanPricing.formatMXN(perPzMax) + '/' + unitAbbr;
        } else {
          maxPriceLabel = LimpiaCleanPricing.formatMXN(unitPrice) + '/' + unitAbbr;
        }
        hintText.innerHTML =
          '<div class="tier-upgrade-info tier-upgrade-max">' +
          '<div class="tier-upgrade-current">🏆 Nivel maximo alcanzado: <strong>' + tier.icon + ' ' + tier.label + ' (-' + tier.discountPercent + '%)</strong></div>' +
          '<div class="tier-upgrade-next" style="color:var(--accent-600)">Mejor precio: ' + maxPriceLabel + '</div>' +
          '</div>';
      }
    }

    // Caja color notice
    var cajaNotice = document.getElementById('caja-color-notice');
    if (cajaNotice) {
      if (currentQty >= cajaSize && hasMultipleColors) {
        cajaNotice.style.display = 'block';
      } else {
        cajaNotice.style.display = 'none';
      }
    }

    // Highlight active tier in table
    var rows = document.querySelectorAll('.tier-row');
    rows.forEach(function(row) {
      if (row.dataset.tierKey === tier.key) {
        row.classList.add('active');
      } else {
        row.classList.remove('active');
      }
    });

    // Update quick add buttons (match qty AND empaque)
    var btns = document.querySelectorAll('.quick-add-btn[data-qty]');
    btns.forEach(function(btn) {
      var btnQty = parseInt(btn.dataset.qty);
      var btnEmpaque = btn.dataset.empaque || '';
      var isActive = btnQty === currentQty && (!btnEmpaque || btnEmpaque === currentEmpaque);
      if (isActive) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  function buildQuickAddButtons() {
    var container = document.getElementById('quick-add-grid');
    if (!container || !config) return;

    var html = '';
    var buttons = [];

    if (piecesPerUnit > 1) {
      // PACK PRODUCT (e.g. 50 Pack): show Pack, Caja, then tier quantities
      // Uses ACTUAL Shopify variant prices for Pack and Caja
      var tiers = LimpiaCleanPricing.getTiers();
      var shown = {};
      var hasCajaVariant = cajaPrice > 0;

      // Button: 1 Pack (uses Pack variant)
      buttons.push({
        label: 'Pack',
        qty: 1,
        empaque: 'pack',
        desc: '1 pack (' + piecesPerUnit + ' pzs)',
        pricePerPieza: packPrice / piecesPerUnit,
        pricePerPack: packPrice,
        pricePerCaja: 0,
        total: packPrice
      });
      shown['pack_1'] = true;

      // Button: 1 Caja (uses Caja variant with ACTUAL price)
      if (hasCajaVariant) {
        buttons.push({
          label: 'Caja',
          qty: 1,
          empaque: 'caja',
          desc: cajaPacks + ' packs (' + piecesPerCaja.toLocaleString() + ' pzs)',
          pricePerPieza: cajaPrice / piecesPerCaja,
          pricePerPack: cajaPrice / cajaPacks,
          pricePerCaja: cajaPrice,
          total: cajaPrice
        });
        shown['caja_1'] = true;
      } else {
        // No Caja variant — fallback: calculate from pack price
        var cajaTier = LimpiaCleanPricing.getTierForQty(piecesPerCaja);
        var fallbackCajaTotal = packPrice * cajaTier.multiplier * cajaPacks;
        buttons.push({
          label: 'Caja',
          qty: cajaPacks,
          empaque: 'pack',
          desc: cajaPacks + ' packs (' + piecesPerCaja.toLocaleString() + ' pzs)',
          pricePerPieza: (packPrice * cajaTier.multiplier) / piecesPerUnit,
          pricePerPack: packPrice * cajaTier.multiplier,
          pricePerCaja: fallbackCajaTotal,
          total: fallbackCajaTotal
        });
        shown['pack_' + cajaPacks] = true;
      }

      // Tier-based buttons (in cajas, using Caja variant price with tier discount)
      tiers.forEach(function(tier) {
        if (tier.key === 'retail') return;
        // BY-AMOUNT: cajas para alcanzar el monto $ del tier (precio retail por caja)
        var cajaUnitRetail = cajaPrice > 0 ? cajaPrice : (packPrice * cajaPacks);
        var cajasNeeded = (typeof tier.minAmt === 'number' && cajaUnitRetail > 0)
          ? Math.max(1, Math.ceil(tier.minAmt / cajaUnitRetail))
          : Math.max(1, Math.ceil(tier.minQty / piecesPerCaja));
        var shownKey = 'caja_' + cajasNeeded;
        if (shown[shownKey]) return;
        shown[shownKey] = true;
        var totalPcs = cajasNeeded * piecesPerCaja;
        var totalPacks = cajasNeeded * cajaPacks;

        if (hasCajaVariant) {
          // Use Caja variant price × tier multiplier
          var tierCajaPrice = cajaPrice * tier.multiplier;
          buttons.push({
            label: tier.label,
            qty: cajasNeeded,
            empaque: 'caja',
            desc: cajasNeeded + (cajasNeeded === 1 ? ' caja' : ' cajas') + ' (' + totalPacks + ' packs / ' + totalPcs.toLocaleString() + ' pzs)',
            pricePerPieza: tierCajaPrice / piecesPerCaja,
            pricePerPack: tierCajaPrice / cajaPacks,
            pricePerCaja: tierCajaPrice,
            total: tierCajaPrice * cajasNeeded
          });
        } else {
          // Fallback: pack price × tier mult × packs
          var tierPackPrice = packPrice * tier.multiplier;
          buttons.push({
            label: tier.label,
            qty: totalPacks,
            empaque: 'pack',
            desc: cajasNeeded + (cajasNeeded === 1 ? ' caja' : ' cajas') + ' (' + totalPacks + ' packs / ' + totalPcs.toLocaleString() + ' pzs)',
            pricePerPieza: tierPackPrice / piecesPerUnit,
            pricePerPack: tierPackPrice,
            pricePerCaja: tierPackPrice * cajaPacks,
            total: tierPackPrice * totalPacks
          });
        }
      });
    } else if (packSize > 1 || hasEmpaqueVariants) {
      var tiers = LimpiaCleanPricing.getTiers();
      var shown = {};

      if (hasEmpaqueVariants) {
        // Products with actual Individual/Pack/Caja Shopify variants (MicroWaffle, etc.)
        // Button: Individual
        if (individualPrice > 0) {
          buttons.push({
            label: 'Unitario',
            qty: 1,
            empaque: 'individual',
            desc: '1 ' + unitSingular,
            pricePerPieza: individualPrice,
            pricePerPack: packPrice > 0 ? packPrice : 0,
            pricePerCaja: cajaPrice > 0 ? cajaPrice : 0,
            total: individualPrice
          });
          shown['individual_1'] = true;
        }

        // Button: 1 Pack
        if (packPrice > 0) {
          buttons.push({
            label: 'Pack',
            qty: 1,
            empaque: 'pack',
            desc: '1 pack (' + packSize + ' ' + unitPlural + ')',
            pricePerPieza: packPrice / packSize,
            pricePerPack: packPrice,
            pricePerCaja: cajaPrice > 0 ? cajaPrice : (packPrice * cajaPacks),
            total: packPrice
          });
          shown['pack_1'] = true;
        }

        // Button: 1 Caja
        if (cajaPrice > 0) {
          buttons.push({
            label: 'Caja',
            qty: 1,
            empaque: 'caja',
            desc: cajaPacks + ' packs (' + cajaSize + ' ' + unitPlural + ')',
            pricePerPieza: cajaPrice / cajaSize,
            pricePerPack: cajaPrice / cajaPacks,
            pricePerCaja: cajaPrice,
            total: cajaPrice
          });
          shown['caja_1'] = true;
        }

        // Tier-based buttons (in cajas if available, else packs)
        tiers.forEach(function(tier) {
          if (tier.key === 'retail') return;
          if (cajaPrice > 0) {
            // BY-AMOUNT: cajas para alcanzar el monto $ del tier
            var cajasNeeded = (typeof tier.minAmt === 'number' && cajaPrice > 0)
              ? Math.max(1, Math.ceil(tier.minAmt / cajaPrice))
              : Math.max(1, Math.ceil(tier.minQty / cajaSize));
            var shownKey = 'caja_' + cajasNeeded;
            if (shown[shownKey]) return;
            shown[shownKey] = true;
            var totalPcs = cajasNeeded * cajaSize;
            var totalPacks = cajasNeeded * cajaPacks;
            var tierCajaPrice = cajaPrice * tier.multiplier;
            buttons.push({
              label: tier.label,
              qty: cajasNeeded,
              empaque: 'caja',
              desc: cajasNeeded + (cajasNeeded === 1 ? ' caja' : ' cajas') + ' (' + totalPacks + ' packs / ' + totalPcs.toLocaleString() + ' ' + unitPlural + ')',
              pricePerPieza: tierCajaPrice / cajaSize,
              pricePerPack: tierCajaPrice / cajaPacks,
              pricePerCaja: tierCajaPrice,
              total: tierCajaPrice * cajasNeeded
            });
          } else if (packPrice > 0) {
            // BY-AMOUNT: packs para alcanzar el monto $ del tier
            var packsNeeded = (typeof tier.minAmt === 'number' && packPrice > 0)
              ? Math.max(1, Math.ceil(tier.minAmt / packPrice))
              : Math.max(1, Math.ceil(tier.minQty / packSize));
            var shownKey = 'pack_' + packsNeeded;
            if (shown[shownKey]) return;
            shown[shownKey] = true;
            var totalPcs = packsNeeded * packSize;
            var tierPackPrice = packPrice * tier.multiplier;
            buttons.push({
              label: tier.label,
              qty: packsNeeded,
              empaque: 'pack',
              desc: packsNeeded + (packsNeeded === 1 ? ' pack' : ' packs') + ' (' + totalPcs.toLocaleString() + ' ' + unitPlural + ')',
              pricePerPieza: tierPackPrice / packSize,
              pricePerPack: tierPackPrice,
              pricePerCaja: 0,
              total: tierPackPrice * packsNeeded
            });
          }
        });
      } else {
        // packSize > 1 WITHOUT empaque variants (e.g. guantes without separate variant options)
        // Button: 1 unit
        buttons.push({
          label: 'Unitario',
          qty: 1,
          desc: '1 ' + unitSingular,
          price: config.price
        });
        shown[1] = true;

        // Button: 1 Pack
        if (!shown[packSize]) {
          var packTier = LimpiaCleanPricing.getTierForQty(packSize);
          buttons.push({
            label: 'Pack',
            qty: packSize,
            desc: '1 pack (' + packSize + ' ' + unitPlural + ')',
            price: config.price * packTier.multiplier
          });
          shown[packSize] = true;
        }

        // Button: 1 Caja
        if (!shown[cajaSize]) {
          var cajaTier = LimpiaCleanPricing.getTierForQty(cajaSize);
          buttons.push({
            label: 'Caja',
            qty: cajaSize,
            desc: cajaPacks + ' packs (' + cajaSize + ' ' + unitPlural + ')',
            price: config.price * cajaTier.multiplier,
            note: 'Mismo color'
          });
          shown[cajaSize] = true;
        }

        // Tier-based buttons
        tiers.forEach(function(tier) {
          if (tier.key === 'retail') return;
          // BY-AMOUNT: unidades para alcanzar el monto $ del tier (precio individual)
          var unitRetail = config.price || 0;
          var unitsNeeded = (typeof tier.minAmt === 'number' && unitRetail > 0)
            ? Math.max(1, Math.ceil(tier.minAmt / unitRetail))
            : tier.minQty;
          var cajasNeeded = Math.ceil(unitsNeeded / cajaSize);
          unitsNeeded = cajasNeeded * cajaSize;
          if (shown[unitsNeeded]) return;
          shown[unitsNeeded] = true;
          var packsNeeded = cajasNeeded * cajaPacks;
          buttons.push({
            label: tier.label,
            qty: unitsNeeded,
            desc: cajasNeeded + (cajasNeeded === 1 ? ' caja' : ' cajas') + ' (' + packsNeeded + ' packs / ' + unitsNeeded.toLocaleString() + ' ' + unitPlural + ')',
            price: config.price * tier.multiplier
          });
        });
      }
    } else {
      // Product sold individually: show quantities based on tiers
      // BY-AMOUNT: piezas para alcanzar el monto $ del tier
      var tiers = LimpiaCleanPricing.getTiers();
      var unitRetail = config.price || 0;
      tiers.forEach(function(tier) {
        var qtyForTier = (typeof tier.minAmt === 'number' && unitRetail > 0)
          ? Math.max(1, Math.ceil(tier.minAmt / unitRetail))
          : tier.minQty;
        var unitLabel = qtyForTier === 1 ? unitSingular : unitPlural;
        buttons.push({
          label: tier.label,
          qty: qtyForTier,
          desc: qtyForTier.toLocaleString() + ' ' + unitLabel,
          price: config.price * tier.multiplier
        });
      });
    }

    buttons.forEach(function(btn) {
      var priceHTML = '';
      var onclickStr = '';
      if (piecesPerUnit > 1 || hasEmpaqueVariants) {
        // Product with per-pieza/per-pack/per-caja breakdown
        var fmt = LimpiaCleanPricing.formatMXN;
        var pzLabel = piecesPerUnit > 1 ? 'pza' : unitAbbr;
        priceHTML = '<div class="quick-add-price">' + fmt(btn.pricePerPieza) + '/' + pzLabel + '</div>';
        if (btn.pricePerPack > 0) {
          priceHTML += '<div class="quick-add-pack-price">' + fmt(btn.pricePerPack) + '/pack</div>';
        }
        if (btn.pricePerCaja > 0) {
          // Show per-caja price
          if (btn.qty === 1 || btn.empaque === 'pack') {
            priceHTML += '<div class="quick-add-total">' + fmt(btn.pricePerCaja) + '/caja</div>';
          } else {
            // Multiple cajas: show per-caja + total
            priceHTML += '<div class="quick-add-total">' + fmt(btn.pricePerCaja) + '/caja</div>';
            priceHTML += '<div class="quick-add-total">' + fmt(btn.total) + ' (' + btn.qty + ' cajas)</div>';
          }
        }
        // Build onclick with empaque
        onclickStr = 'LimpiaCleanProduct.setQty(' + btn.qty + ',\'' + (btn.empaque || 'pack') + '\')';
      } else if (packSize > 1) {
        // GUANTES: btn.price = price per PAR at the tier
        var perUnit = btn.price;
        var perPack = perUnit * packSize;
        var totalForBtn = perUnit * btn.qty;
        if (btn.qty >= cajaSize && btn.qty % cajaSize === 0) {
          var numCajas = btn.qty / cajaSize;
          priceHTML =
            '<div class="quick-add-price">' + LimpiaCleanPricing.formatMXN(perUnit) + '/' + unitAbbr + '</div>' +
            '<div class="quick-add-pack-price">' + LimpiaCleanPricing.formatMXN(perPack) + '/pack</div>' +
            '<div class="quick-add-total">' + LimpiaCleanPricing.formatMXN(totalForBtn) + (numCajas === 1 ? '/caja' : ' (' + numCajas + ' cajas)') + '</div>';
        } else if (btn.qty >= packSize) {
          priceHTML =
            '<div class="quick-add-price">' + LimpiaCleanPricing.formatMXN(perUnit) + '/' + unitAbbr + '</div>' +
            '<div class="quick-add-pack-price">' + LimpiaCleanPricing.formatMXN(perPack) + '/pack</div>' +
            '<div class="quick-add-total">' + LimpiaCleanPricing.formatMXN(totalForBtn) + ' total</div>';
        } else {
          priceHTML = '<div class="quick-add-price">' + LimpiaCleanPricing.formatMXN(perUnit) + '/' + unitAbbr + '</div>';
        }
      } else {
        // SIMPLE PRODUCT: just show per unit price
        priceHTML = '<div class="quick-add-price">' + LimpiaCleanPricing.formatMXN(btn.price) + '/' + unitAbbr + '</div>';
      }
      // Use custom onclick for pack products (includes empaque), default for others
      var clickHandler = onclickStr || ('LimpiaCleanProduct.setQty(' + btn.qty + ')');
      html +=
        '<button class="quick-add-btn" data-qty="' + btn.qty + '" data-empaque="' + (btn.empaque || '') + '" onclick="' + clickHandler + '">' +
        '<div class="quick-add-label">' + btn.label + '</div>' +
        '<div class="quick-add-desc">' + btn.desc + '</div>' +
        priceHTML +
        (btn.note ? '<div class="quick-add-note">' + btn.note + '</div>' : '') +
        '</button>';
    });
    container.innerHTML = html;
  }

  function buildTierTable() {
    var tbody = document.getElementById('tier-table-body');
    if (!tbody || !config) return;

    var tiers = LimpiaCleanPricing.getTiers();
    var html = '';
    var colClass = '';

    if (piecesPerUnit > 1) {
      // PACK PRODUCT: show cajas/packs, price per caja, per pack, per pieza
      var piecesPerCaja = cajaPacks * piecesPerUnit;
      colClass = 'tier-cols-6';
      // Header row
      html += '<div class="tier-row tier-header">' +
        '<div class="tier-cell tier-level">Nivel</div>' +
        '<div class="tier-cell tier-range">Cantidad</div>' +
        '<div class="tier-cell tier-caja-price">$/Caja</div>' +
        '<div class="tier-cell tier-unit-price">$/Pack</div>' +
        '<div class="tier-cell tier-per-piece">$/Pieza</div>' +
        '<div class="tier-cell tier-discount">Desc.</div>' +
        '</div>';
      tiers.forEach(function(tier) {
        var hasCaja = cajaPrice > 0;
        // Use actual Caja variant price as base, apply tier multiplier
        var tierCajaPrice, tierPackPrice, tierPiecePrice;
        if (hasCaja) {
          tierCajaPrice = cajaPrice * tier.multiplier;
          tierPackPrice = tierCajaPrice / cajaPacks;
          tierPiecePrice = tierCajaPrice / piecesPerCaja;
        } else {
          // Fallback: calculate from pack price
          tierPackPrice = packPrice * tier.multiplier;
          tierPiecePrice = tierPackPrice / piecesPerUnit;
          tierCajaPrice = tierPackPrice * cajaPacks;
        }
        // Show range in cajas — BY-AMOUNT
        var cajaUnitRetail = cajaPrice > 0 ? cajaPrice : (packPrice * cajaPacks);
        var hasAmt = (typeof tier.minAmt === 'number') && cajaUnitRetail > 0;
        var minCajas = hasAmt
          ? Math.max(1, Math.ceil(tier.minAmt / cajaUnitRetail))
          : Math.max(1, Math.ceil(tier.minQty / piecesPerCaja));
        var maxCajas = (hasAmt && typeof tier.maxAmt === 'number')
          ? Math.floor(tier.maxAmt / cajaUnitRetail)
          : (tier.maxQty ? Math.floor(tier.maxQty / piecesPerCaja) : null);
        var rangeText = '';
        if (tier.key === 'retail') {
          rangeText = '1+ packs';
        } else if (maxCajas) {
          rangeText = minCajas + ' - ' + maxCajas + ' cajas';
        } else {
          rangeText = minCajas + '+ cajas';
        }
        // Click = caja variant if available, else packs
        var clickCajas = Math.max(1, minCajas);
        var clickEmpaque = hasCaja ? 'caja' : 'pack';
        var clickQty = hasCaja ? clickCajas : (clickCajas * cajaPacks);
        if (tier.key === 'retail') { clickQty = 1; clickEmpaque = 'pack'; }
        var clickPzs = hasCaja ? clickCajas * piecesPerCaja : clickQty * piecesPerUnit;
        var onclickTier = 'LimpiaCleanProduct.setQty(' + clickQty + ',\'' + clickEmpaque + '\')';
        html +=
          '<div class="tier-row" data-tier-key="' + tier.key + '" data-qty="' + clickQty + '" onclick="' + onclickTier + '" title="' + clickCajas + ' caja(s) = ' + clickPzs.toLocaleString() + ' piezas">' +
          '<div class="tier-cell tier-level"><span class="badge badge-' + tier.key + '">' + tier.label + '</span></div>' +
          '<div class="tier-cell tier-range">' + rangeText + '</div>' +
          '<div class="tier-cell tier-caja-price">' + LimpiaCleanPricing.formatMXN(tierCajaPrice) + '</div>' +
          '<div class="tier-cell tier-unit-price">' + LimpiaCleanPricing.formatMXN(tierPackPrice) + '</div>' +
          '<div class="tier-cell tier-per-piece">' + LimpiaCleanPricing.formatMXN(tierPiecePrice) + '</div>' +
          '<div class="tier-cell tier-discount">' + (tier.discountPercent > 0 ? '-' + tier.discountPercent + '%' : 'Base') + '</div>' +
          '</div>';
      });
      html += '<div class="tier-table-footnote">1 caja = ' + cajaPacks + ' packs = ' + piecesPerCaja.toLocaleString() + ' piezas. Precio base caja: ' + LimpiaCleanPricing.formatMXN(cajaPrice > 0 ? cajaPrice : packPrice * cajaPacks) + '. Haz clic en un nivel para seleccionarlo.</div>';
    } else if (packSize > 1 || hasEmpaqueVariants) {
      // Product sold in packs/cajas (e.g. MicroWaffle, guantes)
      var unitLabel = unitSingular.charAt(0).toUpperCase() + unitSingular.slice(1);
      colClass = 'tier-cols-6';
      // Header row
      html += '<div class="tier-row tier-header">' +
        '<div class="tier-cell tier-level">Nivel</div>' +
        '<div class="tier-cell tier-range">Cantidad</div>' +
        '<div class="tier-cell tier-caja-price">$/Caja</div>' +
        '<div class="tier-cell tier-unit-price">$/Pack</div>' +
        '<div class="tier-cell tier-per-piece">$/' + unitLabel + '</div>' +
        '<div class="tier-cell tier-discount">Desc.</div>' +
        '</div>';
      tiers.forEach(function(tier) {
        // Use actual variant prices when available (hasEmpaqueVariants)
        var tierPerPieza, tierPerPack, tierPerCaja;
        if (hasEmpaqueVariants) {
          tierPerPieza = individualPrice > 0 ? individualPrice * tier.multiplier
            : (packPrice > 0 ? (packPrice * tier.multiplier / packSize) : config.price * tier.multiplier);
          tierPerPack = packPrice > 0 ? packPrice * tier.multiplier : tierPerPieza * packSize;
          tierPerCaja = cajaPrice > 0 ? cajaPrice * tier.multiplier : tierPerPack * cajaPacks;
        } else {
          // No empaque variants: calculate from config.price
          tierPerPieza = config.price * tier.multiplier;
          tierPerPack = tierPerPieza * packSize;
          tierPerCaja = tierPerPack * cajaPacks;
        }
        // Show range in cajas — BY-AMOUNT
        var cajaUnitRetail = cajaPrice > 0 ? cajaPrice : ((packPrice > 0 ? packPrice : (config.price || 0)) * cajaPacks);
        var hasAmt = (typeof tier.minAmt === 'number') && cajaUnitRetail > 0;
        var minCajas = hasAmt
          ? Math.max(1, Math.ceil(tier.minAmt / cajaUnitRetail))
          : Math.ceil(tier.minQty / cajaSize);
        var maxCajas = (hasAmt && typeof tier.maxAmt === 'number')
          ? Math.floor(tier.maxAmt / cajaUnitRetail)
          : (tier.maxQty ? Math.floor(tier.maxQty / cajaSize) : null);
        var rangeText = '';
        if (minCajas === 0 || tier.key === 'retail') {
          rangeText = '1+ ' + unitPlural;
        } else if (maxCajas) {
          rangeText = minCajas + ' - ' + maxCajas + ' cajas';
        } else {
          rangeText = minCajas + '+ cajas';
        }
        // Click handler — use empaque for hasEmpaqueVariants
        var clickCajas = Math.max(1, minCajas);
        var clickHandler;
        if (hasEmpaqueVariants && cajaPrice > 0) {
          var cqty = tier.key === 'retail' ? 1 : clickCajas;
          var cemp = tier.key === 'retail' ? 'individual' : 'caja';
          clickHandler = "LimpiaCleanProduct.setQty(" + cqty + ",'" + cemp + "')";
        } else {
          var clickQty = tier.key === 'retail' ? 1 : (clickCajas * cajaSize);
          clickHandler = "LimpiaCleanProduct.setQty(" + clickQty + ")";
        }
        html +=
          '<div class="tier-row" data-tier-key="' + tier.key + '" onclick="' + clickHandler + '" title="' + clickCajas + (clickCajas === 1 ? ' caja' : ' cajas') + ' = ' + (clickCajas * cajaSize) + ' ' + unitPlural + '">' +
          '<div class="tier-cell tier-level"><span class="badge badge-' + tier.key + '">' + tier.label + '</span></div>' +
          '<div class="tier-cell tier-range">' + rangeText + '</div>' +
          '<div class="tier-cell tier-caja-price">' + LimpiaCleanPricing.formatMXN(tierPerCaja) + '</div>' +
          '<div class="tier-cell tier-unit-price">' + LimpiaCleanPricing.formatMXN(tierPerPack) + '</div>' +
          '<div class="tier-cell tier-per-piece">' + LimpiaCleanPricing.formatMXN(tierPerPieza) + '</div>' +
          '<div class="tier-cell tier-discount">' + (tier.discountPercent > 0 ? '-' + tier.discountPercent + '%' : 'Base') + '</div>' +
          '</div>';
      });
      html += '<div class="tier-table-footnote">1 caja = ' + cajaPacks + ' packs × ' + packSize + ' ' + unitPlural + ' = ' + cajaSize + ' ' + unitPlural + '. Haz clic en un nivel para seleccionarlo.</div>';
    } else {
      // Simple product: unit price + discount
      colClass = 'tier-cols-4';
      var unitRetail = config.price || 0;
      tiers.forEach(function(tier) {
        var unitPrice = config.price * tier.multiplier;
        // BY-AMOUNT: rango y click qty se calculan por monto $
        var hasAmt = (typeof tier.minAmt === 'number') && unitRetail > 0;
        var minUnits = hasAmt ? Math.max(1, Math.ceil(tier.minAmt / unitRetail)) : tier.minQty;
        var maxUnits = (hasAmt && typeof tier.maxAmt === 'number')
          ? Math.floor(tier.maxAmt / unitRetail)
          : (tier.maxQty || null);
        var rangeText = maxUnits ? (minUnits.toLocaleString() + ' - ' + maxUnits.toLocaleString()) : (minUnits.toLocaleString() + '+');
        var clickQty = minUnits;
        html +=
          '<div class="tier-row" data-tier-key="' + tier.key + '" data-qty="' + clickQty + '" onclick="LimpiaCleanProduct.setQty(' + clickQty + ')" title="Clic para seleccionar ' + clickQty + ' ' + unitPlural + '">' +
          '<div class="tier-cell tier-level"><span class="badge badge-' + tier.key + '">' + tier.label + '</span></div>' +
          '<div class="tier-cell tier-range">' + rangeText + ' ' + unitPlural + '</div>' +
          '<div class="tier-cell tier-unit-price">' + LimpiaCleanPricing.formatMXN(unitPrice) + '/' + unitAbbr + '</div>' +
          '<div class="tier-cell tier-discount">' + (tier.discountPercent > 0 ? '-' + tier.discountPercent + '%' : 'Base') + '</div>' +
          '</div>';
      });
      html += '<div class="tier-table-footnote">Haz clic en un nivel para seleccionarlo.</div>';
    }
    // Set column class on container for proper grid layout
    tbody.className = colClass;
    tbody.innerHTML = html;
  }

  function setQty(qty, empaque) {
    var input = document.getElementById('product-qty');
    if (input) {
      input.value = qty;
      currentQty = qty;
      var formQty = document.getElementById('form-qty');
      if (formQty) formQty.value = qty;

      // Switch variant based on empaque (pack, caja, or individual)
      if (empaque && (piecesPerUnit > 1 || hasEmpaqueVariants)) {
        currentEmpaque = empaque;
        var currentColor = getCurrentColor();
        var variantInput = document.getElementById('product-variant-id');

        if (empaque === 'caja' && cajaByColor[currentColor]) {
          if (variantInput) variantInput.value = cajaByColor[currentColor].id;
          config.variantId = cajaByColor[currentColor].id;
          config.price = cajaByColor[currentColor].price;
        } else if (empaque === 'pack' && packByColor[currentColor]) {
          if (variantInput) variantInput.value = packByColor[currentColor].id;
          config.variantId = packByColor[currentColor].id;
          config.price = packByColor[currentColor].price;
        } else if (empaque === 'individual' && individualByColor[currentColor]) {
          if (variantInput) variantInput.value = individualByColor[currentColor].id;
          config.variantId = individualByColor[currentColor].id;
          config.price = individualByColor[currentColor].price;
        }

        // Update Empaque selector buttons if they exist
        var empaqueButtons = document.querySelectorAll('[data-option-name="Empaque"]');
        empaqueButtons.forEach(function(eb) {
          var val = (eb.dataset.optionValue || '').toLowerCase();
          if ((empaque === 'caja' && val.indexOf('caja') >= 0) ||
              (empaque === 'pack' && (val.indexOf('pack') >= 0 || val.indexOf('paquete') >= 0) && val.indexOf('caja') < 0) ||
              (empaque === 'individual' && val.indexOf('pack') < 0 && val.indexOf('paquete') < 0 && val.indexOf('caja') < 0)) {
            eb.classList.add('active');
          } else {
            eb.classList.remove('active');
          }
        });
      }

      recalculate();
    }
  }

  function getCurrentColor() {
    var colorBtn = document.querySelector('[data-option-name="Color"].active');
    if (colorBtn) return (colorBtn.dataset.optionValue || '').toLowerCase();
    // Fallback: first color in pack/caja maps
    var keys = Object.keys(packByColor);
    return keys.length > 0 ? keys[0] : 'default';
  }

  function selectVariant(optionName, optionValue, btnEl) {
    if (!config || !config.variants) return;

    // Update active state on buttons for this option group
    var siblings = document.querySelectorAll('[data-option-name="' + optionName + '"]');
    siblings.forEach(function(s) { s.classList.remove('active'); });
    if (btnEl) btnEl.classList.add('active');

    // Collect all active options
    var activeOptions = {};
    var allOptionBtns = document.querySelectorAll('[data-option-name]');
    allOptionBtns.forEach(function(b) {
      if (b.classList.contains('active')) {
        activeOptions[b.dataset.optionName] = b.dataset.optionValue;
      }
    });
    // Override with current selection
    activeOptions[optionName] = optionValue;

    // Find matching variant
    var match = null;
    config.variants.forEach(function(v) {
      var isMatch = true;
      Object.keys(activeOptions).forEach(function(key) {
        var optIndex = -1;
        if (config.variants.length > 0) {
          // Find which option position this name corresponds to
          var sampleVariant = config.variants[0];
          if (sampleVariant.option1 !== null) {
            // We need to check product options order
            var optBtns = document.querySelectorAll('[data-option-name="' + key + '"]');
            if (optBtns.length > 0) {
              var allNames = [];
              document.querySelectorAll('[data-option-name]').forEach(function(b) {
                if (allNames.indexOf(b.dataset.optionName) === -1) allNames.push(b.dataset.optionName);
              });
              optIndex = allNames.indexOf(key);
            }
          }
        }
        if (optIndex === 0 && v.option1 !== activeOptions[key]) isMatch = false;
        if (optIndex === 1 && v.option2 !== activeOptions[key]) isMatch = false;
        if (optIndex === 2 && v.option3 !== activeOptions[key]) isMatch = false;
      });
      if (isMatch && !match) match = v;
    });

    if (match) {
      // Update variant ID for cart
      var variantInput = document.getElementById('product-variant-id');
      if (variantInput) variantInput.value = match.id;

      // Update price with new variant
      config.variantId = match.id;
      config.price = match.price / 100;
      config.available = match.available;

      // Track empaque type for products with empaque variants
      if (piecesPerUnit > 1 || hasEmpaqueVariants) {
        var matchTitle = (match.title || '').toLowerCase();
        if (matchTitle.indexOf('caja') >= 0) {
          currentEmpaque = 'caja';
        } else if (matchTitle.indexOf('pack') >= 0 || matchTitle.indexOf('paquete') >= 0) {
          currentEmpaque = 'pack';
        } else {
          currentEmpaque = piecesPerUnit > 1 ? 'pack' : 'individual';
        }
        // Update variant prices for current color
        var currentColor = (match.option1 || 'default').toLowerCase();
        if (cajaByColor[currentColor]) {
          cajaVariantId = cajaByColor[currentColor].id;
          cajaPrice = cajaByColor[currentColor].price;
        }
        if (packByColor[currentColor]) {
          packPrice = packByColor[currentColor].price;
        }
        if (individualByColor[currentColor]) {
          individualPrice = individualByColor[currentColor].price;
        }
      }

      // Update availability
      var cartBtn = document.getElementById('add-to-cart-btn');
      if (cartBtn) {
        if (match.available) {
          cartBtn.disabled = false;
          cartBtn.textContent = 'Agregar al Carrito';
        } else {
          cartBtn.disabled = true;
          cartBtn.textContent = 'Agotado';
        }
      }

      // Update image if variant has one
      if (match.featured_image && match.featured_image.src) {
        changeImage(match.featured_image.src, null);
      }

      buildQuickAddButtons();
      buildTierTable();
      recalculate();
    }
  }

  function changeImage(src, thumbBtn) {
    var mainImg = document.getElementById('product-main-image');
    if (mainImg) {
      mainImg.style.transform = 'scale(0.95)';
      mainImg.style.opacity = '0.5';
      setTimeout(function() {
        mainImg.src = src;
        mainImg.style.transform = 'scale(1)';
        mainImg.style.opacity = '1';
      }, 200);
    }
    if (thumbBtn) {
      var thumbs = document.querySelectorAll('.gallery-thumb');
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumbBtn.classList.add('active');
    }
  }

  return { init, changeQty, recalculate, setQty, selectVariant, changeImage };
})();


/* --- ANIMATIONS --- */
const LimpiaCleanAnimations = (function() {
  function init() {
    initScrollReveal();
    initHeaderScroll();
  }

  function initScrollReveal() {
    var elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .stagger');
    if (!elements.length) return;

    // Fallback para navegadores sin IntersectionObserver
    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach(function(el) { el.classList.add('visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }

  function initHeaderScroll() {
    var header = document.getElementById('header');
    if (!header) return;

    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  return { init };
})();


/* --- APP (Global) --- */
const LimpiaCleanApp = (function() {
  function init() {
    LimpiaCleanPricing.init();
    LimpiaCleanAnimations.init();
  }

  function toggleMobileNav() {
    var nav = document.getElementById('mobile-nav');
    var overlay = document.getElementById('mobile-overlay');
    var toggle = document.getElementById('mobile-toggle');
    var isOpen = nav && nav.classList.contains('open');
    if (nav) nav.classList.toggle('open');
    if (overlay) overlay.classList.toggle('active');
    if (toggle) toggle.classList.toggle('active');
    // Lock/unlock body scroll
    if (!isOpen) {
      document.body.classList.add('nav-open');
    } else {
      document.body.classList.remove('nav-open');
    }
  }

  function showToast(message, type) {
    type = type || 'success';
    var container = document.getElementById('toast-container');
    if (!container) return;

    var toast = document.createElement('div');
    toast.className = 'toast toast-' + type;
    toast.textContent = message;
    container.appendChild(toast);

    requestAnimationFrame(function() { toast.classList.add('show'); });

    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  return { init, toggleMobileNav, showToast };
})();


/* --- LIMA (WhatsApp Quote Helper) --- */
const LimpiaCleanLIMA = (function() {
  var WA_NUMBER = '525550180617';

  // Try to read from theme settings
  try {
    var links = document.querySelectorAll('a[href*="wa.me/"]');
    if (links.length > 0) {
      var match = links[0].href.match(/wa\.me\/(\d+)/);
      if (match) WA_NUMBER = match[1];
    }
  } catch(e) {}

  function buildQuoteURL(productTitle) {
    var qty = 1;
    var qtyInput = document.getElementById('product-qty');
    if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;

    var tierLabel = '';
    var tierBadge = document.getElementById('product-tier-badge');
    if (tierBadge) tierLabel = tierBadge.textContent.trim();

    var priceEl = document.getElementById('product-price');
    var price = priceEl ? priceEl.textContent.trim() : '';

    var msg = 'Hola LIMA! Me interesa cotizar:\n\n'
      + '- *' + productTitle + '* x' + qty + ' piezas\n';

    if (tierLabel && tierLabel !== 'Retail') {
      msg += '- Nivel: ' + tierLabel + '\n';
    }
    if (price) {
      msg += '- Precio mostrado: ' + price + '\n';
    }
    msg += '\nPor favor envíame la cotización completa.';

    var waNumber = (window.LimpiaClean && window.LimpiaClean.whatsappNumber) || '525550180617';
    return 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg);
  }

  return { buildQuoteURL: buildQuoteURL };
})();


/* --- INIT --- */
document.addEventListener('DOMContentLoaded', function() {
  LimpiaCleanApp.init();

  // Global cart form interceptor — catches forms even if LimpiaCleanProduct.init() hasn't run yet
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    if (!form._cartIntercepted) {
      form._cartIntercepted = true;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!variantInput || !variantInput.value) { form.submit(); return; }
        var variantId = parseInt(variantInput.value, 10);
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (isNaN(variantId)) { form.submit(); return; }
        LimpiaCleanCart.addItem(variantId, qty);
      });
    }
  });

  // On /cart page, populate tier summary on load
  if (window.location.pathname === '/cart' && document.getElementById('cart-page-tier-summary')) {
    LimpiaCleanCart.refreshUI();
  }
});


/* ============================================
   MOBILE AMAZON-STYLE — Sticky ATC + Bottom Nav
   ============================================ */

/* --- Sticky Add-to-Cart: IntersectionObserver --- */
(function() {
  if (window.innerWidth > 768) return;

  var stickyBar = document.querySelector('.sticky-atc');
  var productForm = document.querySelector('.product-actions');

  if (!stickyBar || !productForm) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('visible');
      } else {
        stickyBar.classList.add('visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(productForm);

  // Wire up sticky ATC button to main form submit
  var stickyBtn = stickyBar.querySelector('.sticky-atc__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var mainBtn = document.getElementById('add-to-cart-btn');
      if (mainBtn) mainBtn.click();
    });
  }
})();

/* --- Bottom Nav: Active Tab Highlight --- */
(function() {
  var tabs = document.querySelectorAll('.bottom-nav__tab');
  if (!tabs.length) return;

  var path = window.location.pathname;

  tabs.forEach(function(tab) {
    var href = tab.getAttribute('href');
    if (!href) return;

    if (path === '/' && href === '/') {
      tab.classList.add('active');
    } else if (href !== '/' && path.indexOf(href) === 0) {
      tab.classList.add('active');
    }
  });
})();

/* ═══════════════════════════════════════════════════════════════════════════
   CART INVENTORY CHECK + ALTERNATIVE SUGGESTIONS
   When checking out, verifies stock and suggests alternative variants
   (colors/sizes) if insufficient inventory — so customer maintains tier level
   ═══════════════════════════════════════════════════════════════════════════ */

var CartInventory = {
  init: function() {
    var form = document.getElementById('cart-form');
    if (!form) return;

    var checkoutBtn = form.querySelector('[name="checkout"]');
    if (!checkoutBtn) return;

    checkoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      CartInventory.checkAndProceed(form, checkoutBtn);
    });
  },

  checkAndProceed: function(form, btn) {
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Verificando stock...';

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        // Save original items state
        var origItems = cart.items.map(function(item) {
          return {
            variant_id: item.variant_id,
            quantity: item.quantity,
            handle: item.handle,
            title: item.product_title,
            variant_title: item.variant_title,
            image: item.image,
            price: item.price,
            line_price: item.line_price
          };
        });

        // Validate by updating — Shopify caps at max available inventory
        var updates = {};
        cart.items.forEach(function(i) { updates[i.variant_id] = i.quantity; });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function(r) { return r.json(); })
        .then(function(updated) {
          var issues = [];
          origItems.forEach(function(orig) {
            var upd = updated.items.find(function(i) { return i.variant_id === orig.variant_id; });
            var actualQty = upd ? upd.quantity : 0;
            if (actualQty < orig.quantity) {
              issues.push({
                handle: orig.handle,
                title: orig.title,
                variantTitle: orig.variant_title,
                variantId: orig.variant_id,
                requested: orig.quantity,
                available: actualQty,
                deficit: orig.quantity - actualQty,
                image: orig.image,
                price: orig.price
              });
            }
          });

          btn.disabled = false;
          btn.textContent = origText;

          if (issues.length === 0) {
            form.submit();
          } else {
            CartInventory.showAlternatives(issues, updated);
          }
        });
      })
      .catch(function(err) {
        console.error('Inventory check error:', err);
        btn.disabled = false;
        btn.textContent = origText;
        form.submit();
      });
  },

  showAlternatives: function(issues, updatedCart) {
    var fetches = issues.map(function(issue) {
      return fetch('/products/' + issue.handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var variants = data.product.variants || [];
          issue.alternatives = variants
            .filter(function(v) { return v.id !== issue.variantId && v.available; })
            .map(function(v) {
              return { id: v.id, title: v.title, price: parseFloat(v.price), option1: v.option1, option2: v.option2 };
            });
          return issue;
        })
        .catch(function() { issue.alternatives = []; return issue; });
    });

    Promise.all(fetches).then(function(results) {
      CartInventory.renderModal(results, updatedCart);
    });
  },

  renderModal: function(issues, cart) {
    var old = document.getElementById('inv-modal');
    if (old) old.remove();

    var cartTotal = cart.total_price / 100;
    var tierInfo = CartInventory.getTier(cartTotal);

    var modal = document.createElement('div');
    modal.id = 'inv-modal';
    modal.className = 'inv-overlay';

    var html = '<div class="inv-dialog">';
    html += '<button class="inv-close" onclick="document.getElementById(\'inv-modal\').remove()">&times;</button>';
    html += '<h3 class="inv-title">\u26A0\uFE0F Stock insuficiente</h3>';
    html += '<p class="inv-subtitle">Algunos productos no tienen la cantidad solicitada. Elige alternativas del mismo producto (otro color o medida) para mantener tu nivel de precio:</p>';

    issues.forEach(function(issue) {
      html += '<div class="inv-issue">';
      html += '<div class="inv-issue-header">';
      if (issue.image) html += '<img src="' + issue.image + '" class="inv-thumb" />';
      html += '<div class="inv-issue-info">';
      html += '<strong>' + issue.title + '</strong>';
      if (issue.variantTitle && issue.variantTitle !== 'Default Title') {
        html += ' <span class="inv-variant-label">(' + issue.variantTitle + ')</span>';
      }
      html += '<div class="inv-deficit">';
      html += 'Pediste <strong>' + issue.requested + '</strong>, disponibles: <strong>' + issue.available + '</strong>';
      html += ' &mdash; faltan <strong>' + issue.deficit + '</strong>';
      html += '</div></div></div>';

      if (issue.alternatives.length > 0) {
        html += '<p class="inv-alt-label">\uD83D\uDD04 Misma calidad, otras opciones disponibles:</p>';
        html += '<div class="inv-alt-grid">';
        issue.alternatives.forEach(function(alt) {
          html += '<button class="inv-alt-btn" data-vid="' + alt.id + '" data-qty="' + issue.deficit + '" onclick="CartInventory.addAlt(this)">';
          html += '<span class="inv-alt-name">' + alt.title + '</span>';
          html += '<span class="inv-alt-price">$' + alt.price.toFixed(2) + '</span>';
          html += '<span class="inv-alt-add">+ Agregar ' + issue.deficit + '</span>';
          html += '</button>';
        });
        html += '</div>';
      } else {
        html += '<p class="inv-no-alt">No hay alternativas disponibles de este producto.</p>';
      }
      html += '</div>';
    });

    // Tier impact info
    html += '<div class="inv-tier">';
    html += '<span>' + tierInfo.emoji + ' Tu nivel actual: <strong>' + tierInfo.label + '</strong>';
    if (tierInfo.discount > 0) html += ' (-' + tierInfo.discount + '%)';
    html += '</span>';
    if (tierInfo.nextLabel) {
      html += '<span class="inv-tier-hint">Agrega $' + tierInfo.amtToNext.toLocaleString('es-MX') + ' m\u00E1s para llegar a ' + tierInfo.nextLabel + ' (-' + tierInfo.nextDiscount + '%)</span>';
    }
    html += '</div>';

    html += '<div class="inv-actions">';
    html += '<button class="btn btn-primary" onclick="document.getElementById(\'inv-modal\').remove();document.getElementById(\'cart-form\').submit();">Continuar con lo disponible</button>';
    html += '<button class="btn btn-outline" onclick="document.getElementById(\'inv-modal\').remove()">Seguir comprando</button>';
    html += '</div>';

    html += '</div>';
    modal.innerHTML = html;
    document.body.appendChild(modal);
  },

  addAlt: function(btn) {
    var vid = parseInt(btn.getAttribute('data-vid'));
    var qty = parseInt(btn.getAttribute('data-qty'));
    btn.disabled = true;
    var addSpan = btn.querySelector('.inv-alt-add');
    if (addSpan) addSpan.textContent = 'Agregando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (addSpan) addSpan.textContent = '\u2705 Agregado';
      btn.style.borderColor = 'var(--success)';
      btn.style.background = 'var(--success-light)';
      if (typeof LimpiaCleanCart !== 'undefined') LimpiaCleanCart.refreshUI();
      setTimeout(function() { location.reload(); }, 1200);
    })
    .catch(function() {
      if (addSpan) addSpan.textContent = 'Error \u2014 intenta de nuevo';
      btn.disabled = false;
    });
  },

  getTier: function(amount) {
    // Match Shopify automatic discount thresholds
    var tiers = [
      { label: 'Retail', emoji: '\uD83C\uDFF7\uFE0F', min: 0, discount: 0 },
      { label: 'Mayoreo', emoji: '\uD83D\uDCE6', min: 1500, discount: 10 },
      { label: 'Plata', emoji: '\uD83E\uDD48', min: 5000, discount: 20 },
      { label: 'Oro', emoji: '\uD83E\uDD47', min: 20000, discount: 30 },
      { label: 'Platino', emoji: '\uD83D\uDC8E', min: 80000, discount: 40 }
    ];

    var current = tiers[0];
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (amount >= tiers[i].min) { current = tiers[i]; break; }
    }

    var idx = tiers.indexOf(current);
    var next = idx < tiers.length - 1 ? tiers[idx + 1] : null;

    return {
      label: current.label,
      emoji: current.emoji,
      discount: current.discount,
      nextLabel: next ? next.label : null,
      nextDiscount: next ? next.discount : null,
      amtToNext: next ? Math.ceil(next.min - amount) : 0
    };
  }
};

// Initialize on DOM ready
if (document.readyState !== 'loading') {
  CartInventory.init();
} else {
  document.addEventListener('DOMContentLoaded', CartInventory.init);
}
